/* Language pack: zh */
export const translationsZh = {
	resumeRecording: "继续",
	chatCallMissed: "未接",
	chatCallDeclined: "已拒绝",
	chatAudioConference: "语音会议",
	chatVideoConference: "视频会议",

	IDCardImages: "身份证图片",
	IT: "信息技术",
	Status: "状态",
	abbreviation: "缩写",
	aboutUsItems: "关于我们项目",
	absent: "缺席",
	accept: "接受",
	actSendingDate: "操作发送日期",
	actionTimestamp: "操作时间戳",
	actionType: "操作类型",
	actions: "操作",
	activateStep7_8_9: "分配到电力传输线路部门 ( 7, 8, 9 )",
	activateStep8: "分配到大地测量部门 ( 8 )",
	activatedProjects: "已激活的项目",
	active: "活跃",
	activeCarts: "活跃购物车",
	activeClients: "活跃客户",
	activeCustomers: "活跃客户",
	activeProjectSteps: "活动项目步骤",
	activePromos: "活跃促销",
	activeSales: "活跃销售",
	activeSalesEvents: "活跃销售活动",
	activeServices: "活跃服务",
	activeSteps: "活跃步骤",
	activeStreams: "活跃流",
	activeTasks: "活动任务",
	activeTime: "活跃时间",
	activity: "活动",
	actualHours: "实际时间",
	adInterval: "广告间隔",
	adIntervalOverride: "调度规则",
	adIntervalOverrideDesc: "调度规则",
	adIntervalOverrideValue: "调度规则",
	adPlaylist: "广告播放列表",
	adPlaylists: "广告播放列表",
	adTracks: "广告曲目",
	add: "添加",
	addAttendance: "添加考勤",
	addFeature: "添加功能",
	addFeatureLine: "添加功能行",
	addFiles: "添加文件",
	addMoreFiles: "添加更多文件",
	addNew: "添加新",
	addPriceLine: "添加价格行",
	addRule: "添加规则",
	addToList: "添加到列表",
	addVacationInterval: "添加假期区间",
	added: "已添加",
	additionalDetails: "附加细节",
	address: "地址",
	addressData: "地址数据",
	advanceDeductions: "预支扣款",
	advertisement: "广告",
	age: "年龄",
	ageGroups: "年龄组",
	ago: "以前",
	agreedProjects: "已批准的项目",
	agreementAquipment: "设备协议",
	aiConversations: "对话",
	album: "专辑",
	allArtists: "所有艺术家",
	allAudioTracks: "所有音频曲目",
	allContentItems: "所有内容项",
	allFilesDeleted: "所有文件已永久删除",
	allFilesWillBeDeleted: "所有文件将被永久删除",
	allPlaylists: "所有播放列表",
	allRegisteredContacts: "所有注册客户",
	allTickets: "所有票",
	amount: "金额",
	analytics: "分析",
	answer: "回答",
	apartment: "公寓",
	apply: "应用",
	appsMenu: "应用菜单",
	approved: "已批准",
	approvedInterval: "已批准区间",
	archive: "档案",
	archived: "归档",
	areYouSure: "你确定吗？",
	areYouSureToDelete: "您确定要删除此内容吗？",
	artist: "艺术家",
	artistObject: "艺术家对象",
	assignedTo: "分配给",
	assignedToUser: "分配给",
	assignmentToTheConstructionDepartment: "分配到建设部门",
	attach: "附加",
	attachFile: "附加文件",
	attachments: "附件",
	attendance: "出勤",
	attendanceFlag: "考勤状态",
	attendanceRequiringAttention: "需要关注的员工",
	attendanceNoAttentionItems: "没有需要关注的员工",
	attendanceMissingCheckIn: "缺少签到",
	attendanceMissingCheckOut: "缺少签退",
	attendanceEarlyLeave: "早退",
	attendanceEarlyMissings: "提前离开",
	attendanceEarlyMissingHours: "早退时数",
	attendanceLateHours: "迟到时数",
	attendanceShowWorkedHours: "显示工作时数",
	attendanceUnapprovedAbsence: "未批准的缺勤",
	attendanceDeptAttendance: "部门出勤率",
	attendanceDeviceHealth: "设备健康与实时同步",
	attendanceLastSync: "最近同步",
	attendanceLiveFeed: "实时考勤动态",
	attendanceNoRecentPunches: "暂无最近打卡记录",
	attendanceManualEntryTag: "手动",
	attendanceUnmappedPunch: "未匹配",
	attendancePendingItems: "待处理",
	flexCardTotal: "Flex 卡",
	attendanceCards: "考勤卡",
	flexCardTotalSubtitle: "已分配或已忽略的 Flex ID",
	flexCardsAttached: "已绑定",
	flexCardsAttachedSubtitle: "已绑定到用户的唯一 ID",
	flexCardsIgnored: "已忽略",
	flexCardsIgnoredSubtitle: "在人力资源设置中已忽略",
	flexCardsDuplicateAttached: "重复绑定",
	flexCardIds: "卡片 ID",
	noDuplicateFlexCards: "无重复",
	attendanceTrendPctOfEmployeesPresent: "出勤员工百分比",
	yesterday: "昨天",
	attendanceFilterThisWeek: "本周",
	attendanceFilterThisMonth: "本月",
	attendanceFilterCustom: "自定义",
	attendanceSelectRange: "选择日期范围",
	attendanceCustomRangeCapped: "自定义范围最长为 90 天",
	attendanceLiveBadge: "LIVE",
	attendanceTitleToday: "今日考勤",
	attendanceTitleYesterday: "昨日考勤",
	attendanceTitleThisWeek: "本周考勤",
	attendanceTitleThisMonth: "本月考勤",
	attendanceTitleCustom: "所选期间考勤",
	attendanceTitleTodayKpis: "今日考勤指标",
	attendanceTitleYesterdayKpis: "昨日考勤指标",
	attendanceTitleThisWeekKpis: "本周考勤指标",
	attendanceTitleThisMonthKpis: "本月考勤指标",
	attendanceTitleCustomKpis: "所选期间考勤指标",
	attendanceTrendDays: "考勤趋势 — 最近 {n} 天",
	attendanceNotAttendedYet: "尚未到岗",
	attendanceUpcomingAbsences: "即将到来的缺勤",
	attendanceUpcomingAbsencesEmpty: "暂无即将到来的缺勤",
	attendanceUpcomingAbsencesTomorrow: "明天",
	attendanceUpcomingAbsencesInDays: "{days} 天后",
	attendanceExceptions: "考勤异常",
	attendanceExceptionsMissingCheckIn: "缺少签到",
	attendanceExceptionsMissingCheckOut: "缺少签退",
	attendanceExceptionsEarlyLeaves: "提前离开",
	attendanceExceptionsUnapprovedAbsences: "未批准的缺勤",
	attendanceExceptionsDuplicatePunches: "重复打卡",
	attendanceMonthlyKpis: "月度考勤指标",
	attendanceKpiRate: "出勤率",
	attendanceKpiAvgArrival: "平均到岗时间",
	attendanceKpiLateArrivals: "迟到次数",
	attendanceKpiAbsentDays: "缺勤天数",
	attendanceKpiOvertimeHours: "加班小时数",
	attendanceLeaveBalanceOverview: "假期余额概览",
	attendanceLeaveBalanceVacationRemaining: "剩余年假",
	attendanceLeaveBalanceSickUsed: "已用病假",
	attendanceLeaveBalanceBusinessTrips: "出差次数",
	attendanceLeaveBalancePendingRequests: "待处理申请",
	attendanceLeaveBalanceCoverage: "{total} 名员工中的 {covered} 名",
	attendanceTopInsights: "重点考勤洞察",
	attendanceInsightNoData: "暂无可用的洞察数据",
	attendanceInsightHighestLateness: "{dept} 本周迟到率最高（{delta}）",
	attendanceInsightFullAttendanceToday: "{dept} 出勤率达到 100%",
	attendanceInsightTrendImproved: "出勤率较上一周期提高了 {pct}%",
	attendanceInsightTrendDeclined: "出勤率较上一周期下降了 {pct}%",
	attendanceInsightApproachingOvertime: "{count} 名员工的加班时间接近上限",
	attendancePreviousWeek: "上周",
	attendanceCurrentWeek: "本周",
	attendanceAddInterval: "添加时段",
	attendanceBreakLabel: "休息",
	attendanceCorrectionMode: "更正模式",
	attendanceCustomIntervals: "自定义时段",
	attendanceDashboard: "考勤仪表板",
	attendanceReports: "报告",
	attendanceCalendarTab: "日历",
	reports: "报告",
	shiftCoverage: "班次覆盖",
	previousPeriod: "上一时段",
	nextPeriod: "下一时段",
	failedToSave: "无法保存加班备注",
	expandForDailyDetail: "展开行查看每日详情",
	noDataForPeriod: "此期间无数据",
	attendanceHistory: "考勤历史",
	attendanceDayOffTab: "休息日",
	attendanceDayType: "日期类型",
	attendanceDetectedIntervals: "检测到的时段",
	attendanceEditDay: "编辑日期",
	attendanceHrsTotal: "小时合计",
	attendanceViewWeek: "周",
	attendanceViewMonth: "月",
	attendanceViewDay: "日",
	day: "日",
	attendanceOpenFrom: "自 {time} 起开放",
	attendanceFromStillActive: "自 {time} 起 → 仍在进行",
	attendanceTotalWorked: "总工作时长",
	attendanceMissingUncovered: "缺失 / 未覆盖",
	attendanceNoData: "无数据",
	attendanceNoDataForDay: "这一天没有考勤数据。",
	attendanceIntervalApprovedOk: "已批准 / 正常",
	attendanceIntervalEachRowInvalid: "请为每个时段填写有效的开始和结束时间",
	attendanceIntervalTimesInvalid: "请填写有效的开始和结束时间",
	attendanceIntervalsMode: "时段",
	attendanceIntervalsReviewHint:
		"请核对实际工作、休假与缺漏时段。下方可添加手动调整时段，标记为已批准、办公、远程、病假、带薪假、无薪或其他。",
	attendanceLogSubtitle: "手动考勤录入 — 出勤、病假、休假",
	attendanceLogTitle: "考勤记录",
	attendanceManualResolutionIntervals: "手动调整时段",
	attendanceMissingLabel: "缺卡",
	attendanceNoManualIntervalsYet: "尚未添加手动时段",
	attendanceNoUncovered: "未检测到未覆盖时段",
	attendanceOptionalNotePlaceholder: "可选备注…",
	attendancePtoLeaveSection: "带薪假 / 休假",
	attendanceReport: "考勤报告",
	attendanceResolveInterval: "处理此时段",
	attendanceResyncTooltip: "重新同步该员工的考勤",
	attendanceResyncSuccess: "考勤重新同步已开始",
	attendanceResyncFailed: "考勤重新同步失败",
	attendanceSavedSuccess: "考勤已成功保存",
	attendanceStatusUpcoming: "尚未开始",
	attendanceSelectEmployeePrompt: "选择员工以查看考勤",
	attendanceTrend: "考勤趋势",
	attendanceTrendPctPresent: "% 出勤",
	attendanceUncoveredMissing: "未覆盖 / 缺漏",
	attendanceUnsavedChanges: "未保存的更改",
	attendanceWholeDayStatus: "全天状态",
	shiftWorker: "轮班员工",
	attendanceIgnoreMode: "忽略",
	attendanceIgnoreScopeWeekdays: "星期",
	attendanceIgnoreScopeDateRange: "日期范围",
	attendanceIgnoreScopeWeekdaysHint: "仅适用于此期间内选定的星期几。",
	attendanceIgnoreScopeDateRangeHint: "适用于此期间内的每一天。",
	attendanceIgnoreAppliesTo: "适用于",
	attendanceIgnoreLateArrival: "迟到",
	attendanceIgnoreEarlyLeave: "早退",
	attendanceIgnoreWindowStart: "忽略时段开始",
	attendanceIgnoreWindowEnd: "忽略时段结束",
	attendanceIgnoreRulesList: "忽略规则",
	attendanceIgnoreRulesEmpty: "暂无忽略规则",
	attendanceIgnoreDaysOfWeekRequired: "请至少选择一个星期几",
	attendanceIgnoredLabel: "已忽略",
	attendanceNoCardLabel: "无考勤卡",
	attendanceWork: "工作",
	attendanceWorked: "已工作",
	attendanceWorkedIntervals: "工作时段",
	attendanceMissingIntervals: "缺失时段",
	attendanceStillInOffice: "仍在办公室",
	attendanceAddEvent: "添加事件",
	attendanceAddAttendanceEvent: "添加考勤事件",
	attendanceDeleteEventTitle: "删除考勤事件？",
	attendanceDeleteEventText: "这只会移除此手动添加的打卡事件。",
	attendanceNoMissingIntervals: "当天没有缺失时段",
	attendanceOfficeSince: "自 {time} 起",
	attendanceLastOutAt: "最后签退 {time}",
	attendanceEventSingular: "事件",
	attendanceEventPlural: "事件",
	attendancePunchIn: "进",
	attendancePunchOut: "出",
	solveThis: "去处理",
	editSolvedStatus: "编辑已解决状态",
	officeStatus: "办公室状态",
	outOfOffice: "不在办公室",
	noPunches: "无打卡记录",
	lastActionWasCheckIn: "最后一次操作是签到",
	lastActionWasCheckOut: "最后一次操作是签退",
	noCheckInYet: "尚未签到",
	manual: "手动",
	resolved: "已解决",
	attendanceManualStatusApplyTicketTimeTo: "将工单时间计入",
	attendanceManualStatusColumnAttendanceType: "考勤类型",
	attendanceManualStatusColumnTimeAction: "时间操作",
	attendanceManualStatusMapsToType: "对应考勤类型",
	attendanceManualStatusTicketTimeAction: "工单自动化时间操作",
	attendanceTicketTimePhraseAdd: "增加 {type} 时间",
	attendanceTicketTimePhraseSubtract: "扣减 {type} 时间",
	attendanceTimeOpAdd: "增加工单时间",
	attendanceTimeOpNone: "不改变时间余额",
	attendanceTimeOpSubtract: "扣减工单时间",
	attendanceTypeOptionAbsent: "缺勤",
	attendanceTypeOptionBusinessTrip: "出差",
	attendanceTypeOptionHolidayNonWorking: "节假日 / 非工作日",
	attendanceTypeOptionJustifiedAbsence: "事假（有理由）",
	attendanceTypeOptionMaternity: "产假",
	attendanceTypeOptionPaidVacation: "带薪休假",
	attendanceTypeOptionRemote: "远程办公",
	attendanceTypeOptionSickLeave: "病假",
	attendanceTypeOptionUnjustifiedAbsence: "旷工（无理由）",
	attendanceTypeOptionUnpaidLeave: "无薪假",
	attendanceTypeOptionWork: "工作",
	audio: "音频",
	autoDeletion: "自动删除",
	averageDailyHours: "每日平均工时",
	avgDaily: "日均",
	avgDailyHours: "日均工时",
	avgHoursPerWorkingDay: "每个工作日平均工时",
	avgOrderValue: "平均订单价值",
	avgResolutionTime: "平均解决时间",
	avgResponseTime: "平均响应时间",
	avgTracksPerPlaylist: "平均曲目/播放列表",
	back: "返回",
	bank: "银行",
	bankAccount: "银行账户",
	bankCart: "银行卡",
	bankEmitet: "银行",
	banner: "横幅",
	baseSalary: "基本工资",
	baseSalaryHourlyLinked: "当正常工时 > 0 时，按时薪 = 基本工资 ÷ 正常工时更新。",
	basicInformation: "基本信息",
	beginningOfAcquaintance: "熟悉开始",
	beginningOfContract: "合同开始",
	beginningOfTraining: "培训开始",
	benefits: "福利",
	bestSeller: "畅销",
	bestSellers: "畅销商品",
	bestSellingItemsByRevenue: "按收入排序的热销商品",
	bitrate: "比特率",
	biweekly: "双周",
	blogItems: "博客项目",
	blogs: "博客",
	bonuses: "奖金",
	bpm: "BPM",
	branch: "电网分支",
	branches: "分支列表",
	branchesCitiesVillages: "分支机构、城市、村庄",
	brand: "品牌",
	brands: "品牌",
	building: "建筑",
	businessTrip: "出差",
	buttonText: "按钮文字",
	bypassSteps: "绕过步骤",
	calAddCalendarTooltip: "创建日历并与同事共享",
	calAddEvent: "添加事件",
	calAddReminder: "添加提醒",
	calAlarm15m: "提前 15 分钟",
	calAlarm1d: "提前 1 天",
	calAlarm1h: "提前 1 小时",
	calAlarm1w: "提前 1 周",
	calAlarm2d: "提前 2 天",
	calAlarm2h: "提前 2 小时",
	calAlarm30m: "提前 30 分钟",
	calAlarm5m: "提前 5 分钟",
	calAlarmAtEvent: "事件发生时",
	calAllDay: "全天",
	calApiNotConfigured: "日历 API 未配置。",
	calCalendarColorLabel: "日历颜色",
	calCalendarCreateFailed: "无法创建日历",
	calCalendarCreated: "日历已创建",
	calCalendarDeleted: "日历已删除",
	calCalendarNameLabel: "日历名称",
	calCalendarNamePh: "例如：团队计划",
	calCalendarNameRequired: "请输入日历名称",
	calCalendarSelect: "日历",
	calCalendarUpdateFailed: "无法更新日历",
	calCalendarUpdated: "日历已更新",
	calCalendarsLabel: "日历：",
	calGoogleCalendarLabel: "Google 日历：",
	calGoogleCalendarPrefix: "Google",
	calMeetingsLabel: "会议：",
	calCancel: "取消",
	calCheckAll: "全选",
	calColor: "颜色",
	calCreateCalendar: "创建日历",
	calDay: "日",
	calDayOverviewTitle: "日",
	calDefaultCalendarName: "日历",
	calDelete: "删除",
	calDeleteCalendarHasEvents: "此日历有 {count} 个事件，您想如何处理它们？",
	calDeleteCalendarNoEvents: "此操作无法撤销。",
	calDeleteCalendarOnly: "仅删除日历",
	calDeleteCalendarTitle: "删除日历？",
	calDeleteCalendarWithEvents: "连同事件一起删除",
	calDeleteEventText: "此操作无法撤销。",
	calDeleteEventTitle: "删除事件？",
	calDeleteFailed: "删除失败",
	calDescription: "描述",
	calDescriptionPh: "可选描述",
	calEditCalendarTitle: "编辑日历",
	calEditCalendarTooltip: "编辑日历",
	calEditEvent: "编辑事件",
	calEditTooltip: "编辑",
	calEnd: "结束",
	calEndBeforeStart: "结束不能早于开始",
	calEndTime: "结束时间",
	calEvent: "事件",
	calEventCreated: "事件已创建",
	calEventDeleted: "事件已删除",
	calEventTitle: "标题",
	calEventTitlePh: "事件标题",
	calEventUpdated: "事件已更新",
	calEventsPlural: "个活动",
	calExportIcs: "导出 .ics",
	calFailedLoadEvents: "加载事件失败",
	calHrBirthdayEvent: "生日",
	calHrBirthdays: "生日",
	calHrContractEnd: "合同结束",
	calHrContractEndEvent: "合同结束",
	calHrContractStart: "合同开始",
	calHrContractStartEvent: "合同开始",
	calHrIdEvent: "证件到期",
	calHrIdExpiry: "证件到期",
	calHrPassportEvent: "护照到期",
	calHrPassportExpiry: "护照到期",
	calHrPositionReview: "职位审查",
	calHrPositionReviewEvent: "职位审查",
	calHrSalaryReview: "薪资审查",
	calHrSalaryReviewEvent: "薪资审查",
	calImportButton: "导入",
	calImportEventsTitle: "导入活动",
	calImportFoundInFile: "在文件中找到。选择要导入到的日历：",
	calImportIcs: "导入 .ics",
	calImportedEventTitle: "导入的事件",
	calItLabel: "IT：",
	calItWarrantyEnd: "保修到期",
	calItWarrantyEndEvent: "保修到期",
	calMonth: "月",
	calNewCalendarTitle: "新日历",
	calNewEvent: "新事件",
	calNoCalendar: "无日历",
	calNoCalendarUncategorised: "无日历（未分类）",
	calNoEventsInIcs: ".ics 文件中无事件",
	calNoEventsThisDay: "当天没有活动。",
	calNoRemindersThisDay: "当天没有提醒。",
	calDayWeatherMap: "天气地图",
	calDayHourlyForecast: "逐小时预报",
	calDayWeatherUnavailable: "此日期暂无预报",
	calDayEventsSection: "活动",
	calDayRemindersSection: "提醒",
	calOpenProfile: "打开资料",
	calPeopleLabel: "人员：",
	calReminders: "提醒",
	calRemindersLabel: "提醒：",
	calAttendanceLabel: "考勤：",
	calSecurityLabel: "安全：",
	calSecurityAlerts: "警报",
	calSecuritySessions: "会话",
	calSecurityTokenExpiry: "令牌到期",
	calRemindersToggle: "活动提醒",
	calSave: "保存",
	calSaveFailed: "保存失败",
	calShareWithUsers: "与用户共享",
	calShareWithUsersPh: "搜索并选择人员",
	calStart: "开始",
	calStartEndRequired: "需要开始和结束时间",
	calStartTime: "开始时间",
	calSwalDelete: "删除",
	calTaskHigh: "高",
	calTaskLow: "低",
	calTaskMedium: "中",
	calTaskUrgent: "紧急",
	calTasksLabel: "任务：",
	calTicketsLabel: "工单：",
	calToday: "今天",
	calUserFallback: "用户",
	calWeek: "周",
	calculatePayroll: "计算工资单",
	calculated: "已计算",
	calculations: "计算结果",
	calendarEventType: "日历事件",
	calling: "呼叫",
	cancel: "取消",
	clearText: "清除文本",
	cancelAction: "取消操作",
	cancelBack: "取消返回",
	cancelled: "取消",
	cannotBeUndone: "此操作无法撤销。",
	cannotPayOnline: "无法在线支付",
	cart: "员工",
	categories: "分类",
	category: "类别",
	categoryPerformance: "类别表现",
	certificate: "证书",
	certificateImages: "证书图片",
	certificates: "证书",
	changedDate: "更改日期",
	channel: "频道",
	channelWritePermissionDescription: "只有聊天管理员可以发消息",
	channels: "频道",
	charts: "图表",
	chatActions: "聊天操作",
	chatActiveLabel: "活跃...",
	chatAddOption: "添加选项",
	chatAddUsers: "添加用户",
	chatAddedToGroupNotification: "你已被添加到群聊",
	chatAddedYouToGroup: "已将你添加到",
	chatAudioCall: "语音通话",
	chatBulkDeleteFailed: "批量删除失败。",
	chatBulkForwardFailed: "批量转发失败。",
	chatCallMessage: "通话消息",
	chatChoosingEmoji: "正在选择表情...",
	chatClickMapToChoosePoint: "点击地图选择自定义点。",
	chatCoordinatesUnavailable: "坐标不可用",
	chatCopyCoordinates: "复制坐标",
	chatCopyCoordinatesFailed: "复制坐标失败。",
	chatCreatePoll: "创建投票",
	chatCurrent: "当前",
	chatCurrentLocation: "当前位置",
	chatDashboard: "聊天仪表板",
	chatDeleteFailed: "删除失败",
	chatDeleteForMeOnly: "仅对我删除",
	chatDeleteForParticipants: "也为参与者删除",
	chatDeleteLocation: "删除位置",
	chatDeleteSelectedMessagesDescription:
		"此操作会从聊天视图中移除所选消息。无法按当前权限删除的消息将标记为失败。",
	chatDeleteSelectedMessagesTitle: "删除所选消息",
	chatDeletionPartialWarning: "如果某些消息已被删除或权限检查失败，删除结果可能是部分成功。",
	chatDepartmentSaveFailed: "部门更新失败",
	chatDepartmentSaveFailedTryAgain: "请重新尝试更新部门。",
	chatDeselectAllMessages: "取消全选",
	chatDestinationChatsLabel: "目标聊天",
	chatDestinationChatsPlaceholder: "选择一个或多个聊天",
	chatDirect: "直接聊天",
	chatDirectChat: "私聊",
	chatEditFailed: "无法编辑消息",
	chatEditFailedTryAgain: "请再试一次编辑。",
	chatEditMessagePlaceholder: "编辑消息...",
	writeMessage: "输入消息...",
	chatEditingMessage: "正在编辑消息",
	chatExitSelectionMode: "退出选择模式",
	chatExpired: "已过期",
	chatForwardFailed: "转发失败",
	chatForwardSelectedMessagesTitle: "转发所选消息",
	chatForwardableLabel: "可转发",
	chatGeolocationUnavailable: "此浏览器不支持地理定位。",
	chatGroupChat: "群聊",
	chatGroupInfo: "群组信息",
	chatGroupMembers: "群成员",
	chatGroupSettings: "群组设置",
	chatGroupSettingsDescription: "设置群组图片和关联的人力资源部门",
	chatID: "聊天ID",
	chatImageUploadFailed: "图片上传失败",
	chatImageUploadFailedTryAgain: "请尝试上传其他图片。",
	chatIncludeLabel: "包含",
	chatIsChoosingEmoji: "正在选择表情...",
	chatIsTyping: "正在输入...",
	chatLastUpdated: "最后更新",
	chatLatitude: "纬度",
	chatLive: "实时",
	chatLiveFor: "持续实时",
	chatLiveLocation: "实时位置",
	chatLiveLocationOptInWarning: "实时位置需要明确开启，并可随时停止。",
	chatLiveLocationSharingActive: "实时位置共享已开启",
	chatLoadingLocation: "正在加载位置...",
	chatLoadingPoll: "正在加载投票...",
	chatLongitude: "经度",
	chatMessagesCannotBeForwarded: "条消息无法转发，将被跳过。",
	chatMessagesDeleted: "消息已删除",
	chatMessagesForwarded: "消息已转发",
	chatMoreActions: "更多操作",
	chatNoAvailableUsersToAdd: "所有可用用户都已在此群组中。",
	chatNoBackground: "无背景",
	chatNoChatsFound: "未找到聊天",
	chatNoMessagesForwarded: "没有消息可转发。",
	chatNoSelectedMessagesDeleted: "所选消息均无法删除。",
	chatOpenDepartmentPage: "打开部门页面",
	chatOpenMap: "打开地图",
	chatOptionalAddressLabel: "可选地址标签",
	chatOwnMessagesLabel: "我的",
	chatPartialDelete: "部分删除",
	chatPartialForward: "部分转发",
	chatPattern: "图案",
	chatPickOnMap: "在地图上选择",
	chatPickPointOnMap: "在地图上选择一点。",
	chatPinnedLocation: "固定位置",
	chatPollAddAnotherOption: "添加另一个选项",
	chatPollAddOptionFailed: "添加选项失败。",
	chatPollAllowAddingOptions: "允许添加选项",
	chatPollAllowMultipleAnswers: "允许多选",
	chatPollAllowRevote: "允许重新投票",
	chatPollAnonymous: "匿名投票",
	chatPollAnonymousCannotAddOptions: "匿名测验不能允许添加选项。",
	chatPollAtLeastOptions: "至少需要选项：",
	chatPollAutoClose: "自动关闭",
	chatPollChangeVote: "更改投票",
	chatPollChooseCorrectAnswer: "请至少选择一个正确答案。",
	chatPollCloseDate: "关闭日期",
	chatPollCloseDateOrOpenPeriod: "请仅使用关闭日期或开放时段之一。",
	chatPollCloseFailed: "关闭投票失败。",
	chatPollClosePoll: "关闭投票",
	chatPollCorrectAnswer: "正确答案",
	chatPollCorrectAnswers: "正确答案",
	chatPollCreateFailed: "创建投票失败。",
	chatPollDeletePoll: "删除投票",
	chatPollDescriptionMax: "描述最多",
	chatPollExplanationMax: "说明最多",
	chatPollHideResultsUntilClosed: "关闭前隐藏结果",
	chatPollIncorrectAnswer: "错误答案",
	chatPollLeaveEmptyKeepOpen: "留空以保持投票开启",
	chatPollLeaveEmptyNoTimer: "留空则不设置计时",
	chatPollLoadVotersFailed: "加载投票者失败。",
	chatPollMultipleChoice: "多选",
	chatPollNewOption: "新选项",
	chatPollNoVoteYet: "尚未投票",
	chatPollNoVotersForOption: "此选项暂无投票者。",
	chatPollOpenPeriod: "开放时长",
	chatPollOptionMax: "选项最多",
	chatPollOptionRequired: "选项为必填项。",
	chatPollOptionsUnique: "选项必须唯一。",
	chatPollPublic: "公开",
	chatPollQuestionMax: "问题长度最多",
	chatPollQuestionRequired: "问题为必填项。",
	chatPollQuiz: "测验",
	chatPollQuizExplanation: "测验说明",
	chatPollRegular: "普通",
	chatPollResultsHiddenUntilClosed: "结果将在投票关闭前隐藏。",
	chatPollSearchVoters: "搜索投票者",
	chatPollShuffleOptions: "打乱选项",
	chatPollSingleChoice: "单选",
	chatPollSingleChoiceOneCorrect: "单选测验只能有一个正确答案。",
	chatPollSubmitVoteFailed: "提交投票失败。",
	chatPollViewVoters: "查看投票者",
	chatPollVoteRecorded: "投票已记录",
	chatPollVotersLabel: "票",
	chatPollVotersTitle: "投票者",
	chatPollYouVoted: "您已投票。",
	chatPollYouVotedCanChange: "您已投票，仍可修改答案。",
	chatPreviewChronological: "预览（按时间）",
	chatProvider: "提供商",
	chatReadCurrentLocationFailed: "无法读取您的当前位置。",
	chatRefreshCurrentLocation: "刷新当前位置",
	chatRuleAllow: "是",
	chatRuleDeny: "否",
	chatRuleTimed: "是，但仅限一段时间",
	chatRuleTimerDescription: "例如：设置为 1，则仅允许在发送后的前 1 分钟内执行该操作。",
	chatRuleTimerMinutes: "分钟计时器",
	chatSearchMessage: "搜索消息",
	chatSelectAllMessages: "全选",
	chatSelectDepartment: "选择人力资源部门",
	chatSelectOrLoadLocationFirst: "请先选择或加载位置。",
	chatSelectRepeatingBackground: "选择重复背景",
	chatSelectUsersToAdd: "选择要添加的用户",
	chatSelectedLabel: "已选择",
	chatSelectionMode: "选择模式",
	chatSendCurrentLocation: "发送当前位置",
	chatSendLocationFailed: "发送位置失败。",
	chatSendPinnedLocation: "发送固定位置",
	chatSendVenue: "发送地点",
	chatSentAt: "已发送",
	chatSettings: "聊天设置",
	chatSettingsEditRule: "编辑消息",
	chatSettingsEditRuleDescription:
		"选择已发送消息是否始终可编辑、永不可编辑，或仅在有限时间内可编辑。",
	chatSettingsForwardRule: "转发消息",
	chatSettingsForwardRuleDescription:
		"允许始终转发、禁止转发，或仅在原消息发送后的限定时间内允许转发。",
	chatSettingsGlobalPageSubtitle:
		"在此统一设置私人聊天规则。只有群管理员可以设置群规则。",
	chatSettingsGlobalPageTitle: "全局聊天设置",
	chatSettingsGlobalRulesDescription: "这些规则适用于所有私人聊天。",
	chatSettingsGlobalSavedSuccess: "全局聊天设置已成功更新",
	chatSettingsCompactMode: "紧凑模式",
	chatSettingsCompactModeDescription: "减小间距和头像尺寸，让侧边栏容纳更多聊天。",
	chatSettingsSidebarDescription: "控制聊天在左侧边栏中的显示方式。",
	chatSettingsSidebarTitle: "聊天侧边栏",
	chatSettingsShowLastMessage: "显示最后一条消息",
	chatSettingsShowLastMessageDescription: "在聊天侧边栏中显示最新消息预览及其日期或时间。",
	chatSettingsReplyRule: "回复消息",
	chatSettingsReplyRuleDescription:
		"控制成员是否可以一直回复、永不回复，或仅在消息发送后的时间窗口内回复。",
	chatSettingsResetToGlobal: "恢复群组默认规则",
	chatSettingsRulesAdminOnly: "只有聊天管理员可以更改这些规则。",
	chatSettingsRulesDescription: "设置成员是否可以转发、回复或编辑消息，也可以限制时间。",
	chatSettingsRulesTitle: "聊天规则",
	chatSettingsSaveFailed: "无法保存聊天设置",
	chatSettingsSaveFailedTryAgain: "请再试一次。",
	chatSettingsUsingCustomRules: "此群组使用管理员设置的规则。",
	chatSettingsUsingGlobalRules: "此群组使用默认规则。",
	chatShareLocation: "共享位置",
	chatSkipLabel: "跳过",
	chatSkippedLabel: "已跳过",
	chatStartCall: "开始通话",
	chatStartLiveSharing: "开始实时共享",
	chatStopLiveSharing: "停止实时共享",
	chatType: "聊天类型",
	chatTypeToSearch: "输入以搜索",
	chatTyping: "正在输入...",
	chatUnnamedChat: "未命名聊天",
	chatUpdatingSharedLocationFor: "此共享位置更新剩余",
	chatUploadGroupImage: "上传群组图片",
	chatUserInfo: "用户信息",
	chatUsersSaveFailed: "添加用户失败",
	chatUsersSaveFailedTryAgain: "请重新尝试添加所选用户。",
	chatVenue: "地点",
	chatVenueTitle: "地点标题",
	chatVideoCall: "视频通话",
	chatViewReportedMessages: "查看举报消息",
	chatWaitingDeviceCoordinates: "等待设备坐标...",
	childcarePayment: "托儿补贴",
	chooseBoard: "选择面板以查看其类别和任务",
	cities: "城市",
	city: "城市",
	clear: "清除",
	clearFilters: "清除过滤器",
	clickTheButtonBelowToTakeTheNextStepOnYourJourney: "点击下面的按钮，在您的旅程中迈出下一步",
	contact: "客户",
	contactEngagement: "客户参与度",
	contactGroup: "客户组",
	contactGroups: "客户群组",
	contactPlaylist: "客户端播放列表",
	contactProfile: "客户资料",
	contacts: "客户",
	contactsByGender: "按性别分类的客户",
	contactsByGroup: "按组分类的客户",
	contactsUsing: "客户使用",
	contactsWithCarts: "有购物车的客户",
	contactsWithFavorites: "有收藏的客户",
	clockInOut: "上班 / 下班",
	close: "关闭",
	closeNavigation: "关闭导航",
	closeTicket: "关闭票",
	closed: "关闭",
	closed_late: "逾期后关闭",
	closedDate: "关闭日期",
	closedTickets: "已关闭的票据",
	cmDashboard: "内容管理仪表板",
	code: "代码",
	coin: "硬币",
	coinBurnTime: "销毁时间",
	coinCount: "硬币数量",
	color: "颜色",
	comment: "评论",
	commentTicket: "评论票",
	commissions: "佣金",
	communicationPreferences: "沟通偏好",
	community: "社区",
	company: "公司",
	completed: "已完成",
	completedDate: "完成日期",
	completedTasks: "已完成的任务",
	completionRate: "完成率",
	confirm: "确认",
	confirmAction: "确认操作",
	contactForm: "联系表",
	contactForms: "联系表单",
	contactType: "联系方式",
	contacts: "联系人",
	contentByType: "按类型分类的内容",
	contentItems: "内容项",
	contentManagementOverview: "内容管理系统概览",
	contentOverTime: "随时间创建的内容（最近 30 天）",
	continue: "继续",
	contract: "合同",
	contractEndDate: "合同结束日期",
	contractStartDate: "合同开始日期",
	contractor: "承包商",
	copy: "复制",
	costOfBuildingPart: "建筑部分费用",
	costOfBuildingPermit: "建筑许可证费用",
	country: "国家",
	cpu: "中央处理器",
	create: "订单",
	createBoard: "创建新面板",
	createChat: "创建聊天",
	createGroupChat: "创建群聊",
	createGroupSubmit: "创建",
	addNewCategory: "添加新类别",
	createNewCategory: "创建新类别",
	created: "已创建",
	createdAt: "创建于",
	createdBy: "创建者",
	createdByUser: "由用户创建",
	critical: "严重",
	crmDashboard: "CRM 仪表板",
	cta1: "行动呼叫部分 1",
	cta2: "行动呼叫部分 2",
	cta3: "行动呼叫部分 3",
	currency: "货币",
	currentlyStreaming: "当前正在流式传输",
	currentlyWorking: "当前工作中",
	custom: "自定义",
	customerAcquisition: "客户获取",
	customerBaseOverview: "客户群概览",
	customerInsights: "客户洞察",
	customerRelationshipOverview: "客户关系管理概览",
	dashboard: "仪表板",
	dashboardSubtitle: "仪表板副标题",
	database: "数据库",
	date: "日期",
	dateOfBirth: "出生日期",
	dates: "日期",
	datingAttendance: "约会出席",
	dayOff: "休息日",
	meeting: "会议",
	dayOffForAllEmployees: "全员休息日",
	dayOffRemoved: "已移除休息日",
	dayOffSavedForAllEmployees: "已为所有员工保存休息日",
	days: "天",
	daysLeft: "剩余天数",
	daysOfWeek: "星期几",
	daysWorked: "工作天数",
	deadLine: "截止日期",
	deadline: "截止日期",
	debt: "债务",
	decline: "拒绝",
	deductions: "扣款",
	defaultEnergyMax: "默认能量最大值",
	defaultEnergyMin: "默认最低能量",
	defaultStream: "默认流",
	defaultStreams: "默认流",
	defaultStreamsDesc: "默认流",
	delays: "延误",
	delete: "删除",
	deleteForEveryone: "为所有人删除",
	deletePermanently: "永久删除",
	deleteRule: "删除规则",
	deleteSelected: "删除所选项",
	delivery: "交付",
	deliveryAddress: "送货地址",
	deliveryMethod: "配送方式",
	density: "密度",
	department: "部门",
	departmentChatsHelp: "将群组和频道聊天关联到此部门，并与每个聊天的部门字段保持同步。",
	departmentLinkedChats: "部门聊天",
	departments: "部门",
	desc: "描述",
	description: "描述",
	designer: "设计师",
	detailedFilters: "详细过滤器",
	detailedSteps: "详细步骤",
	details: "详情",
	developed: "开发",
	developedBy: "由...开发",
	difference: "区别",
	diplomaImages: "学位证书图片",
	directMessages: "直接消息",
	disableSteps: "禁用步骤",
	disabledSteps: "禁用步骤",
	disk: "磁盘",
	distributionByPaymentType: "按支付类型分布",
	domainFacility: "设施",
	domainFinance: "财务",
	domainHR: "HR",
	domainIT: "IT",
	domainOther: "其他",
	domainSecurity: "安全",
	done: "完成",
	download: "下载",
	downloadAsContact: "下载为联系人",
	draft: "草稿",
	dragToReorder: "拖动以重新排序",
	dropFilesHere: "将文件拖到这里",
	dropFilesHereOrClick: "将文件拖到这里或点击添加更多",
	dropzoneText: "将图片拖到此处或点击选择文件",
	dueDate: "截止日期",
	duration: "持续时间",
	ecommerceDashboard: "电子商务仪表板",
	edit: "编辑",
	editComment: "编辑备注",
	editItem: "编辑项",
	editProject: "编辑项目",
	editRule: "编辑规则",
	edited: "已编辑",
	editingRule: "编辑规则",
	email: "电子邮件",
	sendEmail: "发送电子邮件",
	employee: "员工",
	employeesPerDepartment: "每个部门的员工",
	employerExpenses: "雇主支出",
	employmentStatus: "就业状态",
	emptyTrash: "清空垃圾桶",
	end: "结束",
	endDate: "结束日期",
	endDateMustBeLaterThanStartDate: "结束日期必须晚于开始日期",
	endDateShort: "结束日期",
	endOfTraining: "培训结束",
	endTime: "结束时间",
	ends: "结束",
	energyLevel: "能量水平",
	energyScheduling: "能量调度",
	enterAmount: "输入金额",
	enterFeatureSuffix: "输入功能后缀",
	enterFeatureText: "输入功能文本",
	enterGroupName: "输入群组名称...",
	enterLabel: "输入标签",
	enterPersons: "输入人数",
	enterRuleName: "输入规则名称",
	entry: "入口",
	error: "错误",
	errorMessage: "发生错误，请重试。",
	errorOccurred: "发生错误",
	errorPageButton: "带我回家",
	errorPageHelpText: "需要帮助？联系我们的支持团队",
	errorPageSecondaryButton: "报告此问题",
	errorPageSubtitle: "您要找的页面不存在",
	errorPageText:
		"别担心，这发生在最好的人身上！页面可能已被移动、删除，或者您可能输入了错误的URL。让我们帮您回到正轨。",
	errorPageTitle: "哎呀！出了点问题",
	errorUserNotFound: "未找到用户",
	estimatedHours: "估计时间",
	eventType: "事件类型",
	exit: "出口",
	expectedSalary: "预期薪资",
	expireDate: "到期日",
	expired: "已过期",
	expiresOn: "到期",
	expiringIdCards: "即将到期的身份证",
	expiringPassports: "即将到期的护照",
	export: "导出",
	exportData: "导出数据",
	extraLarge: "超大",
	extraSmall: "超小",
	faqQuestions: "常见问题",
	favorites: "收藏夹",
	features: "功能",
	female: "女性",
	fields: "领域",
	file: "文件",
	fileHasBeenRemoved: "文件已删除",
	fileMovedToTrash: "文件已移动到垃圾桶",
	fileRestored: "文件已恢复",
	fileWillBeMovedToTrash: "文件将被移动到垃圾桶",
	files: "文件",
	filesRestored: "文件已恢复",
	filesWillBePermanentlyDeleted: "个文件将被永久删除。",
	filter: "过滤器",
	filterBy: "过滤",
	filters: "过滤器",
	finish: "完成",
	fired: "解雇",
	firstIn: "首次打卡",
	firstName: "名字",
	forgotPassword: "忘记密码?",
	forward: "转发",
	forwardMessage: "转发消息",
	forwarded: "已转发",
	forwardedFrom: "从转发",
	fri: "星期五",
	from: "从",
	fromAttendanceLogs: "根据该员工与期间的考勤记录填充；可调整。",
	fromDb: "来自数据库",
	fromHrSettings: "人力资源设置",
	gallery: "画廊",
	genderDistribution: "性别分布",
	globalFilter: "全局过滤器",
	globalSearchClose: "关闭",
	globalSearchCmd_goCalendar_desc: "日历事件",
	globalSearchCmd_goCalendar_label: "前往日历",
	globalSearchCmd_goChat_desc: "打开消息",
	globalSearchCmd_goChat_label: "前往聊天",
	globalSearchCmd_goCrm_desc: "客户管理",
	globalSearchCmd_goCrm_label: "前往 CRM",
	globalSearchCmd_goFinance_desc: "财务模块",
	globalSearchCmd_goFinance_label: "前往财务",
	globalSearchCmd_goHr_desc: "人力资源模块",
	globalSearchCmd_goHr_label: "前往人力资源",
	globalSearchCmd_goIt_desc: "IT 设备",
	globalSearchCmd_goIt_label: "前往 IT",
	globalSearchCmd_goProjects_desc: "项目数据库",
	globalSearchCmd_goProjects_label: "前往项目",
	globalSearchCmd_goRadio_desc: "音乐和播放列表",
	globalSearchCmd_goRadio_label: "前往广播",
	globalSearchCmd_goTickets_desc: "支持工单系统",
	globalSearchCmd_goTickets_label: "前往工单",
	globalSearchCmd_goTodo_desc: "看板与任务",
	globalSearchCmd_goTodo_label: "前往待办",
	globalSearchCmd_messageUser_desc: "打开聊天发送消息",
	globalSearchCmd_messageUser_label: "私信用户",
	globalSearchCmd_newContact_desc: "添加 CRM 客户",
	globalSearchCmd_newClient_label: "新建客户",
	globalSearchCmd_newOrder_desc: "创建订单",
	globalSearchCmd_newOrder_label: "新建订单",
	globalSearchCmd_newProject_desc: "创建项目",
	globalSearchCmd_newProject_label: "新建项目",
	globalSearchCmd_newTask_desc: "创建任务",
	globalSearchCmd_newTask_label: "新建任务",
	globalSearchCmd_newTicket_desc: "创建支持工单",
	globalSearchCmd_newTicket_label: "新建工单",
	globalSearchCommandBadge: "命令",
	globalSearchCommands: "命令",
	globalSearchCopied: "已复制！",
	globalSearchCopyLink: "复制链接",
	globalSearchDirectMessage: "私信",
	globalSearchFilterAll: "全部",
	globalSearchFilterCalendar: "日历",
	globalSearchFilterChats: "聊天",
	globalSearchFilterDevices: "设备",
	globalSearchFilterEcom: "电商",
	globalSearchFilterFinance: "财务",
	globalSearchFilterPeople: "人员",
	globalSearchFilterProjects: "项目",
	globalSearchFilterRadio: "广播",
	globalSearchFilterTickets: "工单",
	globalSearchFilterTodo: "待办",
	globalSearchHidePreview: "隐藏预览",
	globalSearchNavigate: "导航",
	globalSearchOpen: "打开",
	globalSearchOpenInNewTab: "在新标签页打开",
	globalSearchPageBadge: "页面",
	globalSearchPlaceholder: "在 APIT 中搜索任意内容（用户、工单、聊天、设备…）",
	globalSearchPreviewAddress: "地址",
	globalSearchPreviewArtist: "艺术家",
	globalSearchPreviewChat: "聊天",
	globalSearchPreviewCompany: "公司",
	globalSearchPreviewCreated: "创建时间",
	globalSearchPreviewDeviceId: "设备 ID",
	globalSearchPreviewEmail: "电子邮件",
	globalSearchPreviewEmployeeNumber: "员工编号",
	globalSearchPreviewEnd: "结束",
	globalSearchPreviewInfo: "信息",
	globalSearchPreviewIp: "IP",
	globalSearchPreviewLocation: "地点",
	globalSearchPreviewMac: "MAC",
	globalSearchPreviewNumber: "号码",
	globalSearchPreviewOrderNumber: "订单号",
	globalSearchPreviewPhone: "电话",
	globalSearchPreviewSent: "发送时间",
	globalSearchPreviewStart: "开始",
	globalSearchPreviewUsername: "用户名",
	globalSearchPreviewVendor: "供应商",
	globalSearchPreviewVersion: "版本",
	globalSearchRecentSearches: "最近搜索",
	globalSearchRecentlyOpened: "最近打开",
	globalSearchSectionArtists: "艺术家",
	globalSearchSectionAttendanceDevices: "考勤设备",
	globalSearchSectionBrands: "品牌",
	globalSearchSectionCalendarEvents: "日历事件",
	globalSearchSectionCameras: "摄像头",
	globalSearchSectionChats: "聊天",
	globalSearchSectionClientGroups: "客户组",
	globalSearchSectionClients: "客户",
	globalSearchSectionCpus: "处理器",
	globalSearchSectionDepartments: "部门",
	globalSearchSectionEcomCategories: "分类",
	globalSearchSectionFinanceCardIssuers: "发卡机构",
	globalSearchSectionFinanceCards: "卡片",
	globalSearchSectionFinanceCategories: "财务类别",
	globalSearchSectionFinanceTransactions: "交易",
	globalSearchSectionGpus: "显卡",
	globalSearchSectionKeyboards: "键盘",
	globalSearchSectionLaptops: "笔记本电脑",
	globalSearchSectionMessages: "消息",
	globalSearchSectionMice: "鼠标",
	globalSearchSectionMonitors: "显示器",
	globalSearchSectionOrders: "订单",
	globalSearchSectionPcs: "电脑",
	globalSearchSectionPlaylists: "播放列表",
	globalSearchSectionPositions: "职位",
	globalSearchSectionPrinters: "打印机",
	globalSearchSectionProblems: "问题",
	globalSearchSectionProducts: "产品",
	globalSearchSectionProjects: "项目",
	globalSearchSectionRams: "内存",
	globalSearchSectionRoms: "存储",
	globalSearchSectionRooms: "房间",
	globalSearchSectionRouters: "路由器",
	globalSearchSectionSmbs: "SMB",
	globalSearchSectionSoftware: "软件",
	globalSearchSectionSwitches: "交换机",
	globalSearchSectionTelephones: "电话",
	globalSearchSectionTickets: "工单",
	globalSearchSectionTodoBoards: "看板",
	globalSearchSectionTodoCategories: "分类",
	globalSearchSectionTodoTasks: "任务",
	globalSearchSectionTracks: "曲目",
	globalSearchSectionUsers: "人员",
	globalSearchSectionWarrantyProviders: "保修提供商",
	globalSearchSelectPreview: "选择一项以预览",
	globalSearchShortcutHint: "Ctrl + K",
	globalSearchShowPreview: "显示预览",
	globalSearchSubtitle: "跨所有模块搜索",
	globalSearchSuggest1: "搜索分配给我的工单",
	globalSearchSuggest2: "按邮箱查找员工",
	globalSearchSuggest3: "搜索聊天消息",
	globalSearchSuggest4: "按 IP 查找设备",
	globalSearchSuggest5: "按电话搜索客户",
	globalSearchSuggest6: "前往项目",
	globalSearchTrySearchingFor: "试试搜索",
	goBack: "返回",
	goToMessage: "前往消息",
	goToUserAttendanceTab: "用户 → 考勤",
	goToUserAttendanceTabTooltip: "在人事用户页面打开该员工的考勤标签",
	gpu: "图形处理器",
	grossSalary: "税前工资",
	group: "组",
	groupChat: "群聊",
	groupChatWritePermissionDescription: "聊天中的所有成员都可以发消息",
	groupChats: "群聊",
	groupName: "群组名称（可选）",
	healthInsurance: "健康保险",
	healthInsuranceBenefit: "健康保险（福利）",
	help: "帮助",
	hideAllSteps: "隐藏所有步骤",
	hideHistory: "隐藏历史记录",
	hideProjectDetails: "隐藏项目详情",
	hideTableColumnFilters: "隐藏列筛选",
	hideTimeline: "隐藏时间线",
	high: "高",
	highestSpendingCustomers: "消费最高的客户",
	highlight: "突出",
	highlightFeature: "突出功能",
	history: "历史",
	historyTable: "历史表",
	holiday: "节假日",
	holidayNonWorking: "假日 / 非工作日",
	hourlyRate: "时薪",
	hourlyRateBaseLinked: "当正常工时 > 0 时，按基本工资 = 时薪 × 正常工时更新。",
	hr2025RateReferenceTables: "2025 年税率参考表",
	hrAccrualAnnualTotal: "年度合计：{amount} 天",
	hrAccrualDaily: "按日（÷ 365）",
	hrAccrualEachDay: "每天：+{amount} 天假期",
	hrAccrualEachMonthFirst: "每月1日：+{amount} 天假期",
	hrAccrualMethod: "累积方式",
	hrAccrualMethodDesc: "假期如何累积",
	hrAccrualMonthly: "按月（÷ 12，每月1日）",
	hrAccrualMonthlyEquivalent: "月度折合：约 {amount} 天",
	hrAccrualPreview: "累积预览",
	hrArmeniaIncomeTaxCalculator: "亚美尼亚所得税计算器",
	hrArmeniaTaxRates: "亚美尼亚税率",
	hrCalcSummaryGrossToNet:
		"登记工资为 {gross} AMD 时，扣除税费与缴费 {deductions} AMD 后，您将到手 {net} AMD。",
	hrCalcSummaryNetToGross: "若要到手 {net} AMD，合同上的税前工资须为 {gross} AMD。",
	hrCalculationBreakdown: "计算明细",
	hrCalculationDirection: "计算方向",
	hrDefaultBenefitsDescription: "除非按员工单独覆盖，否则这些默认值适用于所有工资计算。",
	hrDefaultMonthlyBenefits: "默认月度福利（AMD）",
	hrDesiredNetSalaryLabel: "期望实发金额（到手）",
	hrEmployeePensionLabel: "员工养老金：",
	hrEmployeePensionRate: "员工养老金费率",
	hrEmployeePensionRateDesc: "1973年后出生者强制（2.5%）",
	hrEmployerPensionRate: "雇主养老金费率",
	hrEmployerPensionRateDesc: "雇主养老金缴费（2.5%）",
	hrFailedToSaveSettings: "保存设置失败",
	hrGrossSalaryAMD: "税前工资（AMD）",
	hrGrossSalaryDescription: "请输入劳动合同上列明的金额",
	hrGrossSalaryLabel: "税前工资（登记/合同金额）",
	hrGrossSalaryRegistered: "税前工资（登记）",
	hrGrossToNet: "税前 → 税后",
	hrHealthInsuranceAges: "健康保险（18–65 岁）",
	hrHealthInsuranceBenefit: "健康保险",
	hrHealthInsuranceBenefitDesc: "雇主月度健康保险缴费（AMD）",
	hrHealthInsuranceEmployeeColumn: "员工",
	hrHealthInsuranceEmployeeShare: "健康保险（员工部分）",
	hrHealthInsuranceStateColumn: "国家",
	hrITSector: "IT 行业（所得税 10%）",
	hrITSectorDesc: "持牌 IT 公司员工",
	hrIncomeTax: "所得税",
	hrIncomeTaxLabel: "所得税：",
	hrIncomeTaxRate: "所得税税率",
	hrIncomeTaxRateDesc: "亚美尼亚自2020年起固定20%",
	hrLeaveAccrualConfiguration: "假期累积配置",
	hrLiveRates: "实时税率",
	hrLunchCoverage: "午餐补贴",
	hrLunchCoverageDesc: "月度午餐/餐饮补贴（AMD）",
	hrMandatoryHealthInsurance: "强制医疗保险（18–65 岁）",
	hrMandatoryHealthInsuranceDesc: "包含 2025 年医疗保险档次",
	hrMilitaryStampRate: "兵役印花税费率",
	hrMilitaryStampRateDesc: "不适用请填 0",
	hrMonthlyFee: "月费",
	hrNetSalaryDescription: "输入您希望实际到手的金额",
	hrNetSalaryLabel: "实发工资：",
	hrNetSalaryTakeHome: "实发工资（到手）",
	hrNetToGross: "税后 → 税前",
	hrOvertimeRateMultiplier: "加班费率倍数",
	hrOvertimeRateMultiplierDesc: "例如 1.5× 表示 50% 的加班补贴",
	hrOvertimeRules: "加班规则",
	hrBreakIntervals: "休息时段",
	hrBreakIntervalsDesc:
		"每天固定的时间段（例如午餐时间），对所有人都不计入工作时间。可以添加多个。",
	hrBreakIntervalsEmpty: "尚未配置休息时段",
	hrBreakIntervalStart: "休息开始",
	hrBreakIntervalEnd: "休息结束",
	hrAddBreakInterval: "添加休息时段",
	hrOvertimeThreshold: "加班阈值（小时/天）",
	hrOvertimeThresholdDesc: "超过此时数按加班费率计算",
	hrPensionMandatory: "强制 / 2018年7月前自愿（5%）",
	hrPensionNone: "未参保（0%）",
	hrPensionPost2018: "2018年7月后自愿（5%）",
	hrPensionSystem: "养老金制度",
	hrPensionSystemDesc: "您的养老金参保状态",
	hrSettingsPageSubtitle: "配置工资、休假和考勤规则",
	hrSettingsPageTitle: "人力资源设置",
	hrSettingsUpdatedSuccessfully: "人力资源设置已成功更新",
	hrSickDaysPerYear: "每年病假天数",
	hrSickDaysPerYearDesc: "每个日历年的带薪病假天数",
	hrSocialPaymentPension: "社保缴费（养老金）",
	hrSocialTaxRate: "社会税税率",
	hrSocialTaxRateDesc: "亚美尼亚目前为0%（已由养老金取代）",
	hrStampFee: "印花费用（军事保险基金）",
	hrStampFeeTooltip: "军事保险基金——按税前工资档次分级的固定费用",
	hrStandardWorkSchedule: "标准工作时间表",
	hrStateHealthContribution: "国家医疗补助",
	hrStateHealthContributionNote: "由国家加入您的医保套餐（不从工资扣除）。",
	hrSuffixDays: "天",
	hrSuffixHours: "小时",
	hrSuffixTimes: "×",
	hrSummary: "摘要",
	hrTabDefaultBenefits: "默认福利",
	hrTabLeaveAccrual: "假期累积",
	hrTabTaxCalculator: "税款计算器",
	hrTabTaxesArmenia: "税费（亚美尼亚）",
	hrTabWorkSchedule: "工作时间表",
	hrTaxPreviewTitle: "税款预览（基于 500,000 AMD 税前）",
	hrTaxRatesDescription: "费率适用于税前工资。以百分比输入（例如 20 表示 20%）。",
	hrTaxRatesDisclaimer:
		"依据亚美尼亚 2025–2026 年立法。所得税：标准20%，持牌IT公司10%。养老金：5%（强制/2018前自愿）或固定5%（2018后自愿）。对强制/2018前参保且收入超过500,000 AMD者，养老金适用10%超额费率。发薪务必咨询持证会计师。",
	hrThresholdWarning: "档位边界提示",
	hrThresholdWarningText:
		"您的工资接近档位边界（10万/20万/50万/100万 AMD）。在这些节点印花税和医保会跳档，税前略增也可能导致税后减少。计算器始终显示达到目标税后所需的最低税前。",
	hrTickets: "HR票",
	hrTotalDeductions: "扣款合计",
	hrTotalEmployeeDeductionsLabel: "员工扣款合计：",
	hrTransportAllowance: "交通补贴",
	hrTransportAllowanceDesc: "月度交通福利（AMD）",
	hrVacationDaysPerYear: "每年休假天数",
	hrVacationDaysPerYearDesc: "全年全额额度（亚美尼亚最低：20 天）",
	hrWorkingDayEnd: "工作日结束时间",
	hrWorkingDayEndDesc: "预期下班时间。每日工时由开始/结束时间自动计算",
	hrWorkingDayStart: "工作日开始时间",
	hrWorkingDayStartDesc: "用于考勤和迟到判断的预期上班时间",
	hrWeekendDays: "周末休息日",
	hrWeekendDaysDesc: "选择一周中哪些天属于非工作周末",
	hrWorkingDaysPerWeek: "每周工作日数",
	hrWorkingDaysPerWeekDesc: "周一至周五 = 5，周一至周六 = 6",
	hrWorkingHoursPerDay: "每日工作小时数",
	hrWorkingHoursPerDayDesc: "触发加班前的标准工时",
	href: "链接",
	humanResources: "人力资源",
	id: "ID",
	idCard: "身份证",
	idCardEndDate: "身份证结束日期",
	idCardNo: "身份证号",
	idCardStartDate: "身份证开始日期",
	idCart: "身份证",
	image: "图像",
	immediateSupervisor: "直接上级",
	importance: "重要性",
	important: "重要",
	inProgress: "进行中",
	inSelectedPeriod: "在选定期间",
	inStock: "有库存",
	in_progress: "进行中",
	inactive: "不活跃",
	inactiveTime: "非活跃时间",
	incident: "事件",
	incomeTaxAmount: "所得税金额",
	incomeTaxRate: "所得税税率（%）",
	incomingCall: "来电",
	incomingVideoCall: "来电视频通话",
	incorrectLogin: "您输入了错误的用户名或密码",
	index: "#",
	inputInArmenian: "输入亚美尼亚语",
	inputInLatin: "输入拉丁文",
	inputInNumbers: "以数字输入",
	inputInRussian: "输入俄语",
	inputNumber: "输入号码",
	inputNumbers: "输入数字",
	instagramPosts: "Instagram 帖子",
	insufficientVacationBalance: "假期余额不足",
	interview1: "面试",
	interview2: "见面",
	interview3: "培训",
	interview4: "实习",
	interviewDate: "面试日期",
	interviewTime: "面试时间",
	introSection: "介绍部分",
	invalidDate: "无效的交货日期",
	inventorySummary: "库存摘要",
	ip: "IP",
	ipAddress: "IP地址",
	isActive: "活跃",
	isColor: "颜色",
	isPrivateOffice: "是否为私人办公室",
	isPublic: "公共",
	itTickets: "IT票",
	items: "项目",
	justifiedAbsence: "有理由的缺勤",
	keyText: "关键文本",
	keyboards: "键盘",
	label: "标签",
	language: "语言",
	languagePickerLabel: "语言",
	large: "大",
	last7Days: "最近 7 天登录",
	lastAction: "最近操作",
	lastLogin: "上次登录",
	lastName: "姓氏",
	lastOut: "末次签退",
	lastPunch: "最后一次打卡",
	lasts: "持续时间",
	latestCustomerOrders: "最新客户订单",
	leader: "领导",
	attendanceManagersFilter: "部门负责人",
	attendanceLeadersFilter: "领导",
	leaveBalance: "假期余额",
	linkCopied: "链接已复制",
	listeners: "听众",
	livingAddress: "居住地址",
	loading: "加载中",
	loanDeductions: "贷款扣款",
	localCode: "本地代码",
	logOut: "登出",
	login: "登录",
	loginButton: "登录",
	loginFailed: "登录失败",
	loginFailedMessage: "请检查您的登录凭据",
	loginSuccess: "登录成功",
	loginSuccessMessage: "您已成功登录",
	loginToStartSession: "登录以开始会话",
	logout: "登出",
	low: "低",
	lunchCoverage: "午餐补贴",
	mac: "MAC",
	macAddress: "MAC地址",
	main: "主要",
	itHierarchyAddLaptop: "添加笔记本电脑",
	itHierarchyAttachedPc: "已连接的电脑",
	itHierarchyLaptopsUsingPart: "使用此部件的笔记本电脑",
	itUsedInOtherPlaces: "在其他位置使用",
	mainInformation: "基本信息",
	mainInfo: "基本信息",
	contactInfo: "联系信息",
	personalInfo: "个人信息",
	workingInfo: "工作信息",
	probation: "试用期",
	educationInfo: "教育信息",
	male: "男性",
	manualAdjustments: "手动调整",
	manualAttendanceEntry: "手动录入",
	maps: "地图",
	maritalStatus: "婚姻状况",
	markAllAsRead: "全部标为已读",
	markSelectedAsRead: "将所选标为已读",
	maternityLeave: "产假",
	maxEnergy: "最高能量",
	maxFilesReached: "最大文件数已达到",
	maxSize: "最大尺寸",
	mediaGallery: "媒体画廊",
	mediaGalleryDescription: "媒体画廊描述",
	mediator: "调解员",
	medium: "中",
	members: "成员",
	menu: "菜单",
	message: "消息",
	messages: "消息",
	messagesByType: "按类型分类的消息",
	messagesOverTime: "随时间变化的消息（最近30天）",
	militaryStampAmount: "兵役印花金额",
	militaryStampRate: "兵役印花费率",
	minEnergy: "最低能量",
	minute: "分钟",
	minutes: "分钟",
	missingInterval: "缺失区间",
	mon: "星期一",
	monitor: "显示器",
	monitors: "显示器",
	month: "月份",
	monthly: "按月",
	mood: "情绪",
	more: "附加",
	moreDetailed: "更详细",
	moreThan: "超过",
	motherProject: "母项目",
	mounted: "安装",
	mouses: "鼠标",
	moveToTrash: "移动到垃圾桶",
	movedToTrash: "已移动到垃圾桶",
	myActiveSteps: "我的活动步骤",
	myInvolvement: "我的参与",
	myProjects: "我的项目",
	myRole: "我的角色",
	mySteps: "我的步骤",
	myTickets: "我的票",
	na: "不适用",
	name: "姓名",
	netCash: "现金净额",
	netOfficial: "官方净额",
	netSalary: "净工资",
	newClients: "新客户",
	newClientsOverTime: "随时间新增客户（最近 30 天）",
	newMessage: "新消息",
	newProducts: "新产品",
	newProject: "新项目",
	newProjects: "新项目",
	newThisPeriod: "本期间新增",
	newTicket: "新票",
	newTicketCreatedBy: "由...创建的新票",
	newTracks: "新曲目",
	newTracksOverTime: "随时间新增曲目（最近 30 天）",
	next: "下一个",
	nextComposition: "下一个组成",
	nextStep: "下一步",
	noAccess: "无访问权限",
	noActiveSteps: "没有活动步骤",
	noBoardsFound: "没有找到面板",
	noCategoriesFound: "没有找到类别",
	noCategoryDataAvailable: "无类别数据",
	noContent: "没有内容",
	noCustomerDataAvailable: "无客户数据",
	noData: "没有数据",
	noDataAvailable: "没有可用数据",
	noDataAvailableForSelectedPeriod: "所选期间无数据",
	noDepartment: "没有部门",
	noDepartments: "没有部门",
	noDescription: "没有描述",
	noEmail: "无邮箱",
	noExpiringIdCards: "没有过期的身份证",
	noExpiringPassports: "没有过期护照",
	noGroup: "无组",
	noMediaDescription: "未找到媒体描述",
	noMediaFound: "未找到媒体",
	noMoreItems: "没有更多项目",
	noName: "无名",
	noNeedStep45: "不需要步骤4-5",
	noNotifications: "无通知",
	noOrdersInSelectedPeriod: "所选期间无订单",
	noOvertimeRecords: "未找到加班记录",
	noPaymentDataAvailable: "无支付数据",
	noProjectsAssigned: "没有分配的项目",
	noProjectsAssignedOrInvolved: "没有分配或参与的项目",
	noRecentContacts: "没有最近的客户",
	noRecentContent: "没有最近的内容",
	noRecentTickets: "没有最近的票据",
	noRecentTracks: "没有最近的曲目",
	noRecipientInformation: "没有收件人信息",
	noResponsible: "没有负责人",
	noResult: "没有找到结果",
	noResults: "没有找到结果",
	noResultsFound: "未找到结果",
	noRulesAdded: "调度规则未添加",
	noStatusData: "没有状态数据",
	noSystemDaysOffThisMonth: "本月无系统级休息日",
	noTaskDataAvailable: "没有可用的任务数据",
	noTasksYet: "没有任务",
	noTasksYetDescription: "没有任务",
	noUpcomingBirthdays: "没有即将到来的生日",
	noUsersFound: "未找到用户",
	noUsersInDepartment: "该部门没有用户",
	noWorkHourData: "没有工作时间数据",
	no_priority: "无优先级",
	nonWorking: "非工作日",
	none: "无",
	notAvailable: "产品不可用",
	notCorrectLoginCredentials: "登录凭证不正确",
	notLoggedInToday: "今天未登录",
	notPlaced: "未放置",
	notPresent: "缺席",
	notResponded: "未回复",
	notWorking: "不工作",
	deviceProblems: "设备问题",
	openTickets: "未关闭工单",
	note: "备注",
	nothingFound: "没有找到任何内容",
	notifications: "通知",
	notificationsBellAria: "打开通知",
	similarTicketNotifications: "类似工单通知",
	number: "数",
	"office-map": "办公室地图",
	officeMapActivatePlacement: "启用放置",
	officeMapAgent: "代理",
	officeMapAll: "全部",
	officeMapAttendanceDevice: "考勤设备",
	officeMapAttendanceDevices: "考勤",
	officeMapCable: "电缆",
	officeMapCableLinePlaced: "电缆线路已放置",
	officeMapCableRemovedFromMap: "电缆已从地图中移除",
	officeMapCables: "电缆",
	officeMapCamera: "摄像头",
	officeMapCameras: "摄像头",
	officeMapNvr: "网络录像机 (NVR)",
	officeMapChat: "聊天",
	officeMapChatWasNotCreated: "聊天未创建",
	officeMapConnectToCamera: "连接到摄像头",
	officeMapCpu: "CPU",
	officeMapDeactivate: "停用",
	officeMapDeviceDetails: "设备详情",
	officeMapDeviceId: "设备 ID",
	officeMapDisableDragging: "禁用拖拽",
	officeMapEnableDragging: "启用拖拽",
	officeMapEndDeviceOptional: "结束设备（可选）",
	officeMapFailedToMoveCable: "无法移动电缆",
	officeMapFailedToMoveItem: "无法移动项目",
	officeMapFailedToMoveRoomArea: "无法移动房间区域",
	officeMapFailedToOpenChat: "无法打开聊天",
	officeMapFailedToPlaceItem: "无法放置项目",
	officeMapFailedToPlaceUser: "无法放置用户",
	officeMapFailedToRemoveCable: "无法移除电缆",
	officeMapFailedToRemoveItem: "无法移除项目",
	officeMapFailedToRemoveRoomArea: "无法移除房间区域",
	officeMapFailedToSaveCableLine: "无法保存电缆线路",
	officeMapFailedToSaveRoomArea: "无法保存房间区域",
	officeMapFinishArea: "完成区域",
	officeMapFinishCable: "完成电缆",
	officeMapForbidden: "禁止",
	officeMapIp: "IP",
	officeMapItem: "项目",
	officeMapItemPlaced: "项目已放置",
	officeMapItemRemovedFromMap: "项目已从地图中移除",
	officeMapLaptop: "笔记本电脑",
	officeMapLaptops: "笔记本电脑",
	officeMapLayers: "图层",
	officeMapLinkedItRoom: "关联的 IT 房间",
	officeMapLive: "实时",
	officeMapMac: "MAC",
	officeMapMin: "最少",
	officeMapMonitors: "显示器",
	officeMapNetworkCable: "网线",
	officeMapNoDevicesInArea: "此区域内没有放置设备或用户。",
	officeMapNoPermissionToPlaceItem: "您没有放置此项目的权限。",
	officeMapNoPermissionToPlaceNetworkCable: "您没有放置网线的权限。",
	officeMapNoPermissionToPlaceRoomArea: "您没有放置房间区域的权限。",
	officeMapNoPermissionToRemoveItem: "您没有从地图中移除此项目的权限。",
	officeMapNoPermissionToRemoveNetworkCable: "您没有从地图中移除网线的权限。",
	officeMapNoPermissionToRemoveRoomArea: "您没有从地图中移除房间区域的权限。",
	officeMapNotAvailable: "不可用",
	officeMapNotConnected: "未连接",
	officeMapPc: "电脑",
	officeMapPcs: "电脑",
	officeMapPlacement: "放置",
	officeMapPleaseSelectItemFirst: "请先选择项目",
	officeMapPleaseSelectRoomFirst: "请先选择房间",
	officeMapPoints: "点",
	officeMapPorts: "端口",
	officeMapPrinted: "已打印",
	officeMapPrinters: "打印机",
	officeMapRam: "RAM",
	officeMapRemoveFromMap: "从地图中移除",
	officeMapRom: "ROM",
	officeMapRoomArea: "房间区域",
	officeMapRoomAreaPlaced: "房间区域已放置",
	officeMapRoomAreaRemovedFromMap: "房间区域已从地图中移除",
	officeMapRoomAreas: "房间",
	officeMapRoomContents: "房间内容",
	officeMapRouter: "路由器",
	officeMapRouters: "路由器",
	officeMapSelectItem: "选择项目",
	officeMapSelectRoom: "选择房间",
	officeMapSpeed: "速度",
	officeMapStartDeviceOptional: "起始设备（可选）",
	officeMapSwitches: "交换机",
	officeMapTelephone: "电话",
	officeMapTelephones: "电话",
	officeMapUnknown: "未知",
	officeMapUrl: "URL",
	officeMapUserPlacedOnMap: "用户已放置在地图上",
	officeMapUsers: "用户",
	officeMapViewContents: "查看内容",
	officeMapViewFullDetails: "查看完整详情",
	offline: "离线",
	offlinePaymentOnly: "仅限离线付款",
	oldProject: "旧项目",
	onSale: "在售",
	onSecond: "在第二",
	onTime: "准时",
	onTimeRate: "准时率",
	oneOf: "之一",
	open: "打开",
	openBoard: "打开面板",
	openDate: "打开日期",
	openInModal: "在模态窗口中打开",
	openInNewTab: "在新标签页中打开",
	openNavigation: "打开导航",
	openedDate: "开放日期",
	optional: "可选",
	orClickToSelect: "或点击选择文件",
	order: "订单",
	orderNumber: "订单号",
	orders: "订单",
	ordersCart: "订单图表",
	otAfterWork: "下班后加班",
	otBeforeWork: "上班前加班",
	otherBenefits: "其他福利",
	otherDeductions: "其他扣款",
	otherInsurance: "其他保险",
	outOfStock: "缺货",
	overdue: "逾期",
	overtimeComment: "加班备注",
	overtimeDays: "加班天数",
	overtimeHours: "加班时数",
	overtimeRate: "加班费率",
	overtimeSummary: "加班汇总",
	overtimeTotal: "加班总计",
	overview: "概览",
	owner: "所有者",
	ownership: "所有权",
	pageNotFound: "找不到页面",
	pageNotFoundDescription:
		"糟糕！您要查找的页面不存在或已被移动。它可能已被删除、更名或暂时不可用。",
	pages: "页面",
	paid: "已付款",
	paidStatus: "支付状态",
	paidTimeOff: "带薪休假",
	paidTimeOffDays: "带薪休假天数",
	parent: "父母",
	parentCategory: "父类别",
	parentDepartment: "上级部门",
	parentTask: "父任务",
	parentType: "父级类型",
	parentUser: "上级用户",
	participant: "参与者",
	passportEndDate: "护照到期日",
	passportImages: "护照图片",
	passportNo: "护照编号",
	passportStartDate: "护照开始日期",
	password: "密码",
	pause: "暂停",
	paused: "已暂停",
	payDate: "支付日期",
	paymentMethod: "支付方式",
	paymentMethods: "支付方式",
	paymentSystem: "支付系统",
	payrollBreakdown: "工资明细",
	payrollCalcError: "工资计算失败。",
	payrollCalcHint: "员工和期间为必填。点击以计算并保存工资汇总。",
	payrollCalcMissingFields: "请选择员工、期间开始和期间结束。",
	payrollCommentsForEmployee: "给员工留言",
	payrollGeneratedFromAttendance: "根据出勤生成薪资",
	payrollHealthInsurancePremium: "健康保险（保费）",
	payrollIndexLabel: "序号",
	payrollIndexPlaceholder: "序号",
	payrollInternalNotes: "内部备注",
	payrollNotesSection: "备注",
	payrollType: "工资单类型",
	payrollUsesHrSettings:
		"加班、税率及默认福利（餐补、交通、医保）遵循人力资源设置（系统 → 人力资源设置）。",
	pc: "电脑",
	pcHealth: "电脑健康",
	pcs: "电脑",
	pdf: "PDF",
	penalties: "罚款",
	pending: "待处理",
	pensionAmount: "养老金金额",
	pensionRate: "养老金费率",
	periodEnd: "结束时间",
	periodStart: "开始时间",
	permInput_calendarEvent_overlayCustomCalendars: "自定义日历（筛选开关）",
	permInput_calendarEvent_overlayIt: "IT 日历（PC 保修叠加）",
	permInput_calendarEvent_overlayPeople: "人员日历（人事叠加）",
	permInput_calendarEvent_overlayReminders: "提醒叠加层",
	permInput_calendarEvent_overlayTasks: "任务（优先级叠加）",
	permInput_calendarEvent_overlayTickets: "工单叠加（按域分组的截止日期）",
	permInput_chat_attachFile: "附加文件",
	permInput_chat_calling: "语音通话",
	permInput_chat_pin: "置顶消息",
	permInput_chat_searchFiles: "在文件中搜索",
	permInput_chat_searchMessages: "在消息中搜索",
	permInput_chat_sendMessage: "发送消息",
	permInput_chat_star: "收藏消息",
	permInput_chat_videoCalling: "视频通话",
	permModuleCrud_download: "日历下载（导入 .ics）",
	permModuleCrud_upload: "日历上传（导出 .ics）",
	permanentDelete: "永久删除？",
	permission: "许可",
	permissions: "权限",
	persons: "人员",
	phone: "电话",
	photo: "照片",
	photos: "照片",
	pickEmoji: "选择表情符号",
	pinnedMessages: "置顶消息",
	placed: "放置",
	placedState: "放置状态",
	placeholder: "占位符",
	platformDashboard: "平台仪表板",
	platformSpecificSettings: "平台特定设置",
	platforms: "平台",
	audioPlaybackSpeed: "播放速度：{rate}。点击更改。",
	playbackMute: "静音",
	playbackUnmute: "取消静音",
	playbackVoiceMessage: "语音消息",
	playbackVideoMessage: "视频消息",
	previewVoiceMessage: "预览语音消息",
	play: "播放",
	playStatus: "播放状态",
	playing: "播放",
	playingComposition: "正在播放的作品",
	playingHistory: "播放历史",
	playlist: "播放列表",
	playlistStatistics: "播放列表统计",
	playlistsWithAds: "带广告的播放列表",
	playlistsWithoutAds: "无广告的播放列表",
	podcast: "播客",
	podcastStreams: "播客流",
	podcasts: "播客",
	ports: "端口",
	position: "职位",
	positionReviewDate: "职位审查日期",
	preDefinedFilters: "预定义过滤器",
	preview: "预览",
	previous: "上一个",
	previousStep: "上一步",
	price: "价格",
	priceB2b: "企业价格",
	priceBasic: "基本价格",
	priceGroup1: "价格组 1",
	priceGroup2: "价格组 2",
	priceGroup3: "价格组 3",
	priceLists: "价格表",
	printedCount: "打印数量",
	printer: "打印机",
	printers: "打印机",
	priority: "优先级",
	priorityDescription: "优先描述",
	private: "私人",
	privateChat: "私聊",
	privateChatDescription: "只有被选中的用户可以看到并加入此聊天",
	problem: "问题",
	problemDescription: "问题描述",
	problemGroup: "问题组",
	problemGroupSupervisorsPlaceholder: "负责处理此问题组工单的用户",
	problemGroupSupervisorsTab: "监督员",
	processTime: "处理时间",
	processing: "处理中",
	progress: "进度",
	product: "产品",
	productCare: "产品护理",
	products: "产品",
	productsLinked: "关联产品",
	project: "项目",
	projectChanges: "项目变更",
	projectDeadline: "项目截止日期",
	projectDetails: "项目详情",
	projectEndDate: "项目结束日期",
	projectID: "项目ID",
	projectPartition: "项目分区",
	projectPrice: "项目价格",
	projectPrice2: "项目价格",
	projectStartDate: "项目开始日期",
	projectType: "项目类型",
	projectTypes: "项目类型",
	projects: "项目",
	promoCode: "促销代码",
	promoCodes: "促销码",
	promoCodesAndCertificates: "促销码和证书",
	promotions: "促销",
	propertyNumber: "财产编号",
	providing: "提供",
	punchActivity: "打卡动态",
	pto: "带薪休假",
	partial: "部分",
	quantity: "数量",
	radioDashboard: "电台仪表板",
	radioManagementOverview: "电台流媒体管理概览",
	radioStatistics: "电台统计",
	raises: "加薪",
	ram: "内存",
	rate: "比率",
	rating: "评分",
	readOnly: "只读",
	readOnlyChatNotice: "此聊天对成员为只读。只有管理员可以发消息。",
	readyToGetStarted: "准备开始",
	recalculatePayroll: "重新计算工资单",
	recentClients: "最近的客户",
	recentContent: "最近的内容",
	recentMessages: "最近的消息",
	recentOrders: "最近订单",
	recentTickets: "最近的票据",
	recentTracks: "最近的曲目",
	refresh: "刷新",
	registeredAddress: "注册地址",
	regularHours: "正常工时",
	regularHoursHrScheduleHint: "由人力资源设置自动填充：期内工作日 × 每日工时。可编辑。",
	regularPlaylists: "常规播放列表",
	relatedList: "相关列表",
	relatedObjects: "关联对象",
	relatedProducts: "相关产品",
	relatedTasks: "相关任务",
	relations: "关系",
	remainingVacation: "剩余假期",
	remote: "远程",
	remoteWorkDays: "远程办公天数",
	remove: "移除",
	removeFromList: "从列表中移除",
	removeItem: "移除项",
	removed: "已移除",
	reopen: "重新打开",
	replaceableProduct: "可替换产品",
	replaceableProducts: "可替换产品",
	replied: "已回复",
	reply: "回复",
	request: "请求",
	requestedForUser: "请求者",
	reset: "重置",
	responseTimeDistribution: "响应时间分布",
	responsible: "负责人",
	responsibleAndUsers: "负责人和用户",
	restoreSelected: "恢复选定的文件",
	restored: "已恢复",
	returning: "回头客",
	revenue: "收入",
	revenueOverview: "收入概览",
	review: "审查",
	rightNow: "现在",
	role: "角色",
	rom: "只读存储器",
	room: "房间",
	routers: "路由器",
	rpaPrice: "RPA部门工作价格",
	ruleName: "规则名称",
	salary: "工资",
	salaryReviewDate: "薪资审查日期",
	sale: "销售",
	salePrice: "销售价格",
	salesBreakdownByCategory: "按类别分类的销售明细",
	salesPerformanceOverTime: "销售表现随时间变化",
	sat: "星期六",
	save: "保存",
	saveChanges: "保存更改",
	saveComment: "保存备注",
	saved: "已保存",
	schedulingDisabled: "调度已禁用",
	schedulingEnabled: "调度已启用",
	schedulingRules: "计划规则",
	search: "搜索",
	searchByNameOrId: "按姓名或ID搜索…",
	searchChat: "搜索聊天...",
	searchChatGroups: "搜索群组...",
	searchConversations: "搜索对话...",
	searchResults: "搜索结果",
	searchUsers: "搜索用户...",
	secondary: "次要",
	seconds: "秒",
	securityAcknowledge: "确认",
	securityActions: "操作",
	securityActiveBadge: "活动中",
	securityActiveSessions: "活动会话",
	securityActivityStatClicks: "点击",
	securityActivityStatKeys: "按键",
	securityActivityStatMoves: "移动",
	securityActivityTimeline: "活动时间线",
	securityAdminNotes: "管理员备注",
	securityAdminNotesDevice: "关于此设备的内部备注...",
	securityAgentHeartbeat: "代理心跳",
	securityAlertClipPlural: "本页由警报触发的片段",
	securityAlertClipSingular: "本页由警报触发的片段",
	securityAlertCount: "条警报",
	securityAlertCountPlural: "条警报",
	securityAlertDrawerNoMedia:
		"此警报尚无关联媒体。设备上的安全代理需使用 FFmpeg 录制并上传。Windows 上需将 FFmpeg 加入 PATH 或设置 FFMPEG_PATH。请查看代理日志。",
	securityAlertDrawerVideoFailed:
		"已下发视频采集命令但未收到上传。代理可能出错，请查看设备上的代理日志。",
	securityAlertDrawerVideoPending: "正在录制视频，稍后将显示于此。设备上的代理正在采集并上传。",
	securityAlertRecordings: "警报录制",
	securityAlertRecordingsOnly: "仅警报录制",
	securityAlertSt_acknowledged: "已确认",
	securityAlertSt_false_positive: "误报",
	securityAlertSt_open: "未处理",
	securityAlertSt_resolved: "已解决",
	securityAlertsTitle: "安全警报",
	securityAllDevices: "所有设备",
	securityAllEventTypes: "所有类型",
	securityAllRules: "所有规则",
	securityAllSeverities: "所有严重程度",
	securityAllStatuses: "全部状态",
	securityAppProcessTracking: "应用/进程跟踪",
	securityAppTracking: "应用跟踪",
	securityAppUsageToday: "今日应用使用（分钟）",
	securityAssignedUser: "分配用户",
	securityBadgeAlertText: "警报",
	securityBadgeApp: "应用",
	securityBadgeApps: "应用",
	securityBadgeCapture: "采集",
	securityBadgeFiles: "文件",
	securityBadgeOff: "关",
	securityBadgeScr: "截",
	securityBadgeScreenshot: "截图",
	securityBadgeVideo: "视频",
	securityBadgeWeb: "网页",
	securityCapture: "采集",
	securityCaptureEnabledMaster: "采集已启用（主）",
	securityCaptureEverySeconds: "采集间隔（秒）",
	securityCaptureMasterSwitch: "采集已启用（总开关）",
	securityCaptureModes: "采集模式",
	securityCaptureOffAlertBody:
		"已在设备级明确关闭采集，覆盖策略。仍会触发警报，但不录制截图或视频。",
	securityCaptureOffAlertTitle: "采集覆盖：关",
	securityCaptureRecorded: "已记录采集",
	securityCaptureWhenOnDesc: "开启后可进行截图和视频录制；关闭则两者都停用",
	securityChartMinutes: "分钟",
	securityChartVisits: "次访问",
	securityClearFilters: "清除筛选",
	securityClickLeft: "左",
	securityClickMiddle: "中",
	securityClickPlain: "点击",
	securityClickRight: "右",
	securityClipWord: "片段",
	securityConnectedDevices: "已连接设备",
	securityCreated: "创建时间",
	securityDeleteDevice: "删除设备",
	securityDeleteDeviceConfirm: "您确定要删除",
	securityDeleteDeviceNote: "这只会删除安全设备记录。IT中的PC配置文件不会受到影响。",
	securityDeleteDeviceTitle: "删除安全设备",
	securityDeleteMedia: "删除",
	securityDeletePolicyConfirm: "删除此策略？",
	securityDevice: "设备",
	securityDeviceFallback: "设备",
	securityDeviceIdLabel: "设备 ID",
	securityDeviceNotFound: "未找到设备",
	securityDeviceSettings: "设备设置",
	securityDeviceSettingsHint: "覆盖此设备的有效策略。未设置时继承策略。",
	securityDevicesBreadcrumb: "设备",
	securityDevicesTitle: "安全设备",
	securityDevicesWithAlerts: "有警报的设备",
	securityDividerCapture: "采集",
	securityDividerNotes: "备注",
	securityDividerTracking: "跟踪",
	securityDuration: "时长",
	securityEg15: "例如 15",
	securityEg30: "例如 30",
	securityEg300: "例如 300",
	securityEg5: "例如 5",
	securityEg60: "例如 60",
	securityEnabled: "已启用",
	securityEnd: "结束",
	securityEventFlushSeconds: "事件刷新（秒）",
	securityEventsCount: "条事件",
	securityEventsCountPlural: "条事件",
	securityEvtAppProcess: "应用/进程",
	securityEvtAppUsage: "应用使用",
	securityEvtFileEvent: "文件事件",
	securityEvtHeartbeat: "心跳",
	securityEvtInputActivity: "输入活动",
	securityEvtKeystroke: "按键",
	securityEvtMouseClick: "鼠标点击",
	securityEvtSessionEnd: "会话结束",
	securityEvtSessionStart: "会话开始",
	securityEvtSystemBoot: "系统启动",
	securityEvtSystemShutdown: "系统关机",
	securityEvtUsb: "USB 事件",
	securityEvtUserLogin: "用户登录",
	securityEvtUserLogout: "用户注销",
	securityEvtWebVisit: "网页访问",
	securityEvtWorkstationLock: "屏幕已锁定",
	securityEvtWorkstationUnlock: "屏幕已解锁",
	securityFailedLoadOverview: "无法加载安全概览",
	securityFailedSavePolicy: "保存策略失败",
	securityFalsePositiveBtn: "误报",
	securityFileEventTracking: "文件事件跟踪",
	securityFilterByDate: "按日期筛选",
	securityFilterDateRange: "按日期范围筛选",
	securityFilteredSuffix: "（已筛选）",
	securityFps: "帧率",
	securityHostname: "主机名",
	securityInputActivityCounts: "输入活动（计数）",
	securityInputKeystrokeClickTracking: "按键/点击跟踪",
	securityInputModeActivityCountsShort: "仅活动 — 按键/点击计数",
	securityInputModeActivityOnly: "仅活动（计数）",
	securityInputModeDisabled: "禁用",
	securityInputModeDisabledShort: "禁用 — 无输入指标",
	securityInputModeEventsOnly: "仅事件",
	securityInputModeEventsStream: "仅事件 — 原始事件流",
	securityInputModeFullDetail: "完整细节（按键+点击）",
	securityInputModeFullKeystrokes: "完整细节 — 按键与点击位置",
	securityInputModeShort: "输入模式",
	securityInputTrackingMode: "输入跟踪模式",
	securityInternalNotesPlaceholder: "内部备注...",
	securityKeyCharPrefix: "键：",
	securityLastSeen: "最后在线",
	securityLatestClip: "最新片段",
	securityLinkedItPc: "关联的 IT 电脑：",
	securityLiveLoadingSub: "正在连接代理 — 屏幕预览即将显示。",
	securityLiveOfflineHint: "设备离线 — 实时画面需要已连接的代理。",
	securityLivePressStart: "点击开始实时以打开画面流。",
	securityLiveScreenAlt: "实时屏幕",
	securityLiveStatusLive: "直播中",
	securityLiveStatusStandby: "待机",
	securityLiveStreamHint: "流为每帧半分辨率，最高约 10 fps。代理需 v1.4.0+ 并安装 jimp。",
	securityLiveWaitingFrames: "正在加载实时画面…",
	securityLoggedInSince: "登录时间",
	securityLoggedOutSince: "最后注销",
	securityMediaPrefix: "媒体",
	securityMediaTitle: "安全媒体",
	securityMiddleClick: "中键点击",
	securityModuleErrorTitle: "安全模块错误",
	securityName: "名称",
	securityNearbyScreenshots: "附近截图",
	securityNever: "从未",
	securityNewMediaBadge: "新",
	securityNewPolicy: "新建策略",
	securityNoActivityEvents: "无活动事件",
	securityNoAlertRecordingsPage: "本页无警报触发的录制",
	securityNoAlertsForDevice: "此设备无警报",
	securityNoAlertsFound: "未找到警报",
	securityNoDevicesFound: "未找到设备",
	securityNoEventsMatchFilter: "没有匹配此筛选的事件",
	securityNoOpenAlerts: "没有未处理警报",
	securityNoPoliciesConfigured: "尚未配置策略。请创建策略以开始监控。",
	securityNoPreview: "无预览",
	securityNoRiskyDevices: "无高风险设备",
	securityNoScreenshotsFound: "未找到截图",
	securityNoScreenshotsYet: "尚无截图",
	securityNoSessionsFound: "未找到会话",
	securityNoSessionsRecorded: "无会话记录",
	securityNoUserSession: "无用户会话",
	securityNoUserSessionLiveHint: "PC 已开机但无用户登录，直播和截图功能不可用。",
	securityNoUserSessionTitle: "没有用户登录",
	securityNoVideoSegmentsFound: "未找到视频片段",
	securityNoVideosYet: "尚无视频片段",
	securityOS: "系统",
	securityOnlineDevices: "在线设备",
	securityOpenAlerts: "未处理警报",
	securityOpenPcRecord: "打开电脑记录",
	securityOverrideOff: "关",
	securityOverrideOn: "开",
	securityOverridePrefix: "覆盖：",
	securityOverviewTitle: "安全概览",
	securityPageOf: "页",
	securityPolActivityTrackingDivider: "活动跟踪",
	securityPolAfterHoursStart: "非工作时间开始",
	securityPolAlertClipLength: "警报视频片段时长（秒）",
	securityPolAlertScore: "警报分数（0–100）",
	securityPolAlertSeverity: "警报严重程度",
	securityPolAlertVideoDivider: "警报视频录制",
	securityPolAlertVideoInfo:
		"规则触发安全警报时，代理按以下设置录制单段桌面视频。所有规则使用相同的片段长度与质量。",
	securityPolAllowedHoursDivider: "允许采集时段",
	securityPolBadgeAlert: "警报",
	securityPolBlockedApps: "被阻止的应用",
	securityPolBlockedAppsPh: "例如 telegram、discord、torrent",
	securityPolBlockedDomains: "被阻止的域名",
	securityPolBlockedDomainsPh: "例如 torrent-site.com、telegram.org",
	securityPolBreadcrumbPolicies: "策略",
	securityPolBulkThreshold: "批量文件事件阈值（每批事件数）",
	securityPolBulkThresholdDesc: "单批上传中破坏性文件事件数达到此值即触发",
	securityPolCollectInputMetrics: "收集输入活动指标",
	securityPolCollectInputMetricsDesc: "仅鼠标/键盘事件计数（不含按键内容）",
	securityPolCreateAlert: "创建警报",
	securityPolCreateAlertDesc: "规则匹配时打开安全警报（视频使用采集页设置）",
	securityPolDescription: "描述",
	securityPolEditPolicy: "编辑策略",
	securityPolEnableRule: "启用规则",
	securityPolEventsRetention: "事件保留（天）",
	securityPolEventsRetentionDesc: "早于此天数的活动事件记录将被清除",
	securityPolExcludedDomains: "排除的域名",
	securityPolExcludedDomainsPh: "例如 online-banking.com",
	securityPolExcludedProcesses: "排除的进程名",
	securityPolExcludedProcessesPh: "例如 1Password、Bitwarden",
	securityPolInputActivityCounts: "仅活动 — 鼠标/键盘事件计数",
	securityPolInputDisabledNoTrack: "禁用 — 不跟踪输入",
	securityPolInputEventsCount: "仅事件 — 仅按键计数",
	securityPolInputFullDetail: "完整细节 — 按键与点击位置",
	securityPolInputModeLabel: "输入跟踪模式",
	securityPolInputTrackingDivider: "输入跟踪",
	securityPolMaskSensitive: "遮盖敏感窗口（如密码管理器、网银）",
	securityPolMaskSensitiveDesc: "不对排除的应用/窗口截图",
	securityPolMaxFps: "最大帧率",
	securityPolMediaRetention: "媒体保留（天）",
	securityPolMediaRetentionDesc: "早于此天数的截图与视频片段将被删除",
	securityPolNewSecurityPolicy: "新建安全策略",
	securityPolNotifyUsersDesc: "当此策略中的任何规则触发警报时，所选用户将收到应用内通知。",
	securityPolNotifyUsersLabel: "策略触发时通知管理员",
	securityPolNotifyUsersPh: "搜索并选择要通知的用户…",
	securityPolPolicyName: "策略名称",
	securityPolPolicyNamePh: "例如：开发团队策略",
	securityPolPriority: "优先级",
	securityPolPriorityDesc: "数字越大越优先评估",
	securityPolRecordVideoOnAlert: "安全警报时录制视频",
	securityPolRecordVideoOnAlertDesc: "关闭时仍会创建警报，但不录制视频",
	securityPolRuleAfterHoursDesc: "在定义的工作时间外检测到活动时触发。",
	securityPolRuleAfterHoursLabel: "非工作时间活动",
	securityPolRuleBlockedAppDesc: "当被监控用户打开列表中的应用时触发。",
	securityPolRuleBlockedAppLabel: "被阻止的应用",
	securityPolRuleBlockedDomainDesc: "当被监控用户访问列表中的域名时触发。",
	securityPolRuleBlockedDomainLabel: "被阻止的域名",
	securityPolRuleBulkFileDesc: "单批内出现大量文件删除、重命名或移动时触发。",
	securityPolRuleBulkFileLabel: "批量文件操作",
	securityPolRuleUsbDesc: "当 USB 存储设备连接到被监控设备时触发。",
	securityPolRuleUsbLabel: "检测到 USB 存储",
	securityPolRulesIntro:
		"规则定义违规与警报评分。开启「创建警报」时会生成安全警报；视频录制遵循采集页设置（所有规则相同）。",
	securityPolSavePolicy: "保存策略",
	securityPolScope: "范围",
	securityPolScopeDepartment: "部门",
	securityPolScopeDevice: "指定设备",
	securityPolScopeGlobal: "全局 — 适用于所有设备",
	securityPolScopeUser: "指定用户",
	securityPolTabCapture: "采集",
	securityPolTabPrivacy: "隐私与排除项",
	securityPolTabRetention: "保留",
	securityPolTabRules: "规则",
	securityPolTrackApps: "跟踪活动应用",
	securityPolTrackFiles: "跟踪文件活动",
	securityPolTrackWebsites: "跟踪网站访问",
	securityPolTrackingMaster: "跟踪已启用（总开关）",
	securityPolTrackingMasterDesc: "关闭时应用、网页、文件与输入跟踪均停用",
	securityPolVisibleNotice: "向员工显示可见的监控提示",
	securityPolVisibleNoticeDesc: "显示横幅告知员工监控已开启",
	securityPolWorkDayStart: "工作日开始（非工作时间结束）",
	securityPolWorkingHours: "工作时间（可选）",
	securityPolWorkingHoursDesc:
		"仅在此时间段采集。格式：时:分-时:分，如 09:00-18:00。留空表示始终。",
	securityPolWorkingHoursPh: "09:00-18:00",
	securityPoliciesCaptureHint:
		"徽章表示已启用的功能。要开启或关闭截图、视频、应用、网页或文件，请打开策略（铅笔图标）→「采集」选项卡。",
	securityPoliciesTitle: "安全策略",
	securityPolicyDefaultBadge: "策略默认",
	securityPriority: "优先级",
	securityQueued: "已排队！",
	securityRecentOpenAlerts: "近期未处理警报",
	securityRecentScreenshots: "最近截图",
	securityRecordEverySeconds: "录制间隔（秒）",
	securityRecordVideo30s: "录制视频（30 秒）",
	securityRefresh: "刷新",
	securityResolution: "分辨率",
	securityResolutionNotePlaceholder: "解决备注（可选）",
	securityResolve: "解决",
	securityRightClick: "右键点击",
	securityRule: "规则",
	securityRuleCode_AFTER_HOURS: "非工作时间",
	securityRuleCode_BLOCKED_APP: "被阻止的应用",
	securityRuleCode_BLOCKED_DOMAIN: "被阻止的域名",
	securityRuleCode_BULK_FILE_EVENTS: "批量文件事件",
	securityRuleCode_USB_DETECTED: "检测到 USB",
	securitySaveSettings: "保存设置",
	securitySaved: "已保存",
	securityScope: "范围",
	securityScopeType_department: "部门",
	securityScopeType_device: "设备",
	securityScopeType_global: "全局",
	securityScopeType_user: "用户",
	securityScreenshotAlt: "截图",
	securityScreenshotOptionsBlank: "截图选项（留空则使用策略默认）",
	securityScreenshots: "截图",
	securityScreenshotsCount: "截图",
	securityScreenshotsLabel: "截图",
	securityScreenshotsToday: "今日截图",
	securitySearch: "搜索",
	securitySearchDevicesPlaceholder: "搜索主机名、设备 ID、用户...",
	securitySegmentLengthSeconds: "片段时长（秒）",
	securitySelectedCount: "已选",
	securitySessionActive: "活跃",
	securitySessionIdle: "空闲",
	securitySessionLocked: "屏幕已锁定",
	securitySessionLockedCaptureHint: "屏幕已锁定 — 截图和直播不可用。",
	securitySessionLockedLiveHint: "用户已锁定屏幕。屏幕锁定期间，直播、截图和录制均不可用。",
	securitySessionLockedSince: "锁定时间",
	securitySessionLockedTitle: "屏幕已锁定",
	securitySessionNotFound: "未找到会话",
	securitySessionTimeline: "会话时间线",
	securitySessionWord: "会话",
	securitySessionsTitle: "会话",
	securitySettingsDrawerTitle: "设置",
	securitySettingsOverrideHint: "仅覆盖此设备的有效策略。保持不变则继承策略。",
	securitySev_critical: "严重",
	securitySev_high: "高",
	securitySev_low: "低",
	securitySev_medium: "中",
	securitySeverity: "严重程度",
	securityShowAllVideos: "显示全部视频",
	securitySourceEvents: "源事件",
	securitySpeedSec: "速度（秒）：",
	securityStart: "开始",
	securityStartLive: "开始实时",
	securityStatOf: "共",
	securityStatus: "状态",
	securityStatus_error: "错误",
	securityStatus_offline: "离线",
	securityStatus_online: "在线",
	securityStatus_pending: "待处理",
	securityStatus_unknown: "未知",
	securityStopLive: "停止实时",
	securityTabActivity: "活动",
	securityTabAlerts: "警报",
	securityTabLive: "实时",
	securityTabScreenshots: "截图",
	securityTabSessions: "会话",
	securityTabSettings: "设置",
	securityTabVideos: "视频",
	securityTakeScreenshot: "截图",
	securityTitle: "标题",
	securityTooltipAppTrack: "切换应用跟踪",
	securityTooltipCaptureMaster: "切换截图与媒体采集（总开关）",
	securityTooltipScreenshot: "切换截图",
	securityTooltipTrackingMaster: "应用、网页、文件与输入跟踪总开关",
	securityTooltipWebTrack: "切换网站域名跟踪",
	securityTopRiskyDevices: "风险最高的设备",
	securityTracking: "跟踪",
	securityTrackingEnabledMaster: "跟踪已启用（主）",
	securityTrackingMasterSwitch: "跟踪已启用（总开关）",
	securityTrackingOffAlertBody: "已在设备级关闭活动跟踪，覆盖策略。",
	securityTrackingOffAlertTitle: "跟踪覆盖：关",
	securityTrackingWhenOffDesc: "关闭时应用、网页、文件与输入跟踪均停用",
	securityUnassigned: "未分配",
	securityUnknown: "未知",
	securityUnknownDevice: "未知设备",
	securityUsePolicyDefault: "使用策略默认",
	securityUser: "用户",
	securityUserLoggedIn: "已登录",
	securityVideoOffAlertBody: "已在设备级关闭视频录制。即使策略允许也不会录制警报视频。",
	securityVideoOffAlertTitle: "视频覆盖：关",
	securityVideoOptionsBlank: "视频录制选项（留空则策略默认）",
	securityVideoPlayAllHint: "从所选片段起连续播放较早片段；当前页结束后自动加载下一页继续播放。",
	securityVideoRecording: "视频录制",
	securityVideoSegments: "视频片段",
	securityVideoSegmentsCount: "视频片段",
	securityViewDetail: "查看详情",
	securityWebDomainTracking: "网站域名跟踪",
	securityWebPollSeconds: "网页历史轮询（秒）",
	securityWebTracking: "网页跟踪",
	securityWebsiteVisitsToday: "今日网站访问",
	securityWhen: "时间",
	selectAlbum: "选择专辑",
	selectAll: "选择所有",
	selectArtist: "选择艺术家",
	selectBoard: "选择面板",
	selectCategory: "选择类别",
	selectChatPartner: "选择聊天伙伴",
	selectClosedDate: "选择关闭日期",
	selectDate: "选择日期",
	selectDays: "选择天数",
	selectDomain: "选择领域",
	selectEmployee: "选择员工",
	selectFiles: "选择文件",
	selectGroup: "选择组",
	selectOpenedDate: "选择打开日期",
	selectParentDepartment: "选择上级部门",
	selectParentUser: "选择上级用户",
	selectPeriod: "选择期间",
	selectPlatformToManageAndNavigate: "选择一个平台来管理和导航",
	selectPlaylist: "选择播放列表",
	selectProduct: "选择产品",
	selectSomething: "选择一些东西",
	selectUsers: "选择用户",
	selectedSteps: "选定的步骤",
	selectedUsers: "已选用户",
	seleteSelected: "选择选定的文件",
	send: "发送",
	sent: "已发送",
	seoDesc: "SEO 描述",
	servicesAndPrices: "服务和价格",
	setCostOfBuildingPermit: "设置建筑许可证费用",
	setDayOff: "设置休息日",
	settings: "设置",
	shiftSchedule: "班次安排",
	showAllSteps: "显示所有步骤",
	showHistory: "显示历史记录",
	showProjectDetails: "显示项目详情",
	showTableColumnFilters: "显示列筛选",
	showTimeline: "显示时间线",
	showing: "显示中",
	shuffle: "随机播放",
	shuffleEnabled: "已启用随机播放",
	shuffleOverride: "调度规则",
	shuffleOverrideDesc: "调度规则",
	shuffleOverrideValue: "调度规则",
	sickLeave: "病假",
	sickLeaveDays: "病假天数",
	signIn: "登录",
	signUp: "注册",
	size: "尺寸",
	slider: "滑块",
	small: "小",
	smb: "服务器文件夹",
	socialAmount: "社保缴费金额",
	socialCardImages: "社交卡图片",
	socialCart: "社会卡",
	socialNetworkLink: "社交网络链接",
	socialRate: "社保缴费费率",
	software: "软件",
	softwareSkills: "软件技能",
	somethingWentWrong: "出现了问题",
	somethingWentWrongInCreatingSteps: "创建步骤时出现问题！请再试一次",
	sortBy: "排序",
	source: "来源",
	special: "特别",
	specialItems: "特殊商品",
	speed: "速度",
	starred: "星标",
	starredMessages: "星标消息",
	start: "开始",
	startCall: "开始通话",
	startDate: "开始日期",
	startDateShort: "开始日期",
	startRecording: "开始录制",
	startTime: "开始时间",
	startVideoCall: "开始视频通话",
	starts: "开始",
	state: "州",
	states: "州",
	status: "状态",
	visibility: "可见性",
	statusUpdate: "状态更新",
	stayAnonymous: "保持匿名",
	step: "步骤",
	stepIsNotStartedYet: "步骤尚未开始",
	stepStatus: "步骤状态",
	stepStatusChangedByUser: "用户更改了步骤状态",
	steps: "步骤",
	stepsLeft: "剩余步骤",
	stillInOffice: "仍在办公室",
	stockAndProductOverview: "库存和产品概览",
	stop: "停止",
	stopRecording: "停止录制",
	stopped: "已停止",
	streamDJ: "电台DJ",
	streamStatistics: "流统计",
	streaming: "流媒体",
	streamsWithShuffle: "启用随机播放的流",
	street: "街道",
	subDesc: "子描述",
	submit: "提交",
	submittedProjects: "已提交的项目",
	subscription: "订阅",
	subscriptions: "订阅",
	substation: "变电站",
	substationNumber: "变电站编号",
	subtasks: "子任务",
	subtasksPlaceholder: "在每行输入一个子任务",
	subtitle: "副标题",
	success: "成功",
	suffix: "后缀",
	sun: "星期日",
	support: "支持",
	supportText: "对于所有问题写",
	switch: "开关",
	switchers: "切换器",
	switches: "打印机",
	syncedFromGoogleContacts: "已从 Google 联系人同步",
	systemSettings: "系统设置",
	table: "表格",
	tag: "标签",
	tags: "标签",
	takeMeHome: "返回主页",
	taskCreatedSuccessfully: "任务创建成功",
	taskCreatedSuccessfullyDescription: "任务创建成功",
	taskDescription: "任务描述",
	taskMoved: "任务已移动",
	taskMovedDescription: "任务已移动到新类别",
	taskStatusDistribution: "任务状态分布",
	taskTitle: "任务标题",
	tasksAssigned: "分配的任务",
	taxCode: "税码",
	taxNote: "标签",
	taxes: "税费",
	technicalFilesUrl: "技术文件网址",
	telegram: "电报",
	text: "文本",
	theConstructionDepPrice: "建筑部门价格",
	theNumberOfAct: "行为数量",
	thePriceOfProject: "项目价格",
	themePickerLabel: "主题",
	thereIsNoResponsible: "没有负责人",
	thisMonth: "本月",
	thu: "星期四",
	ticket: "票",
	ticketClosed: "工单已关闭",
	ticketCreateSaveDisabledHint: "请选择域、问题组（如有）、问题，并填写所有必填关联字段后再保存。",
	ticketDashboard: "票据仪表板",
	ticketDomain: "领域",
	ticketHierarchyAddProblem: "添加问题",
	ticketHierarchyAddProblemGroup: "添加问题组",
	ticketHierarchyAddRelatedList: "添加关联列表",
	ticketHierarchyAddTicket: "添加工单",
	ticketHierarchyAddTicketDomain: "添加领域",
	ticketHierarchyAddTicketHint: "将打开新建工单并预选此域。",
	ticketHierarchyGroupsInDomain: "此领域下的问题组",
	ticketHierarchyNoneYet: "尚无 — 使用上方按钮添加。",
	ticketHierarchyProblemsInGroup: "此组内的问题",
	ticketHierarchyProblemsLinkedToList: "使用此关联列表的问题",
	ticketSystemOverview: "票据系统性能和指标概览",
	ticketTitle: "标题",
	ticketType: "类型",
	ticketTypeDomainsHint: "留空则所有域都可使用该类型；选择一个或多个域则仅在这些域中显示。",
	ticketTypeDomainsListAll: "所有域",
	ticketStatus_sent: "已发送",
	ticketStatus_in_process: "处理中",
	ticketStatus_resolved_rejected: "已拒绝",
	ticketStatus_resolved_approved: "已批准",
	ticketStatus_moved_next: "已转至下一步",
	ticketStatus_moved_prev: "已退回上一步",
	ticketStatus_closed: "已关闭",
	ticketStatus_not_accepted: "未接受",
	ticketAction_start: "开始处理",
	ticketAction_next: "下一步",
	ticketAction_prev: "上一步",
	ticketAction_approve: "批准",
	ticketAction_reject: "拒绝",
	ticketAction_close: "关闭工单",
	ticketAction_cancel: "取消工单",
	ticketAction_comment: "评论",
	cancelTicket: "取消工单",
	ticketCancelReason: "取消原因",
	ticketCancelComment: "附加说明",
	ticketCancelCommentPlaceholder: "如有需要，为提交人补充说明",
	ticketCancelWarning: "此工单将被标记为未接受并关闭。如果用户仍需要帮助，必须创建新的工单。",
	ticketNotAccepted: "工单未被接受",
	ticketStepStatus_pending: "待处理",
	ticketStepStatus_active: "进行中",
	ticketStepStatus_completed: "已完成",
	ticketStepStatus_approved: "已批准",
	ticketStepStatus_rejected: "已拒绝",
	ticketStepStatus_closed: "已关闭",
	ticketStepStatus_cancelled: "已取消",
	tickets: "票据",
	ticketsByDepartment: "按部门分类的票据",
	ticketsByImportance: "按优先级分类的票据",
	ticketsByProblem: "按问题类型分类的票据",
	ticketsByStatus: "按状态分类的票据",
	ticketsOverTime: "票据随时间变化",
	timAgreement: "TIM协议",
	timDelays: "TIM延误",
	timSentProjects: "已发送至TIM的项目",
	time: "时间",
	timeBasedScheduling: "基于时间的调度",
	timeOff: "休假",
	timeRange: "时间范围",
	timeToClose: "关闭票据的时间",
	timeToFirstResponse: "首次响应时间",
	timeline: "时间线",
	timestamp: "时间戳",
	timezone: "时区",
	title: "标题",
	to: "到",
	toChat: "去聊天",
	toDo: "待办",
	today: "今天",
	todaysSales: "今日销售",
	todo: "任务",
	todoBoard: "面板",
	todoBoards: "面板",
	todoCategories: "类别",
	todoCategory: "类别",
	todoLabel: "标签",
	todoLabels: "标签",
	todoTag: "标签",
	todoTags: "标签",
	todoTask: "任务",
	todoTasks: "任务",
	toggles: "切换",
	top: "顶级",
	topCustomers: "顶级客户",
	topProducts: "热门产品",
	total: "总计",
	totalActiveTasks: "总活动任务",
	totalArtists: "总艺术家数",
	totalChats: "总聊天数",
	totalClients: "客户总数",
	totalCoins: "总硬币数",
	totalContent: "总内容",
	totalCustomers: "客户总数",
	totalDeductions: "扣款合计",
	totalDuration: "总时长",
	totalGroups: "总组数",
	totalHours: "总小时数",
	missingDays: "缺勤天数",
	missingHours: "缺勤小时",
	scheduled: "计划",
	totalHoursWorked: "总工作时间",
	totalInTrash: "垃圾桶中总共",
	totalMessages: "总消息数",
	totalOrders: "订单总数",
	totalOvertime: "总加班时间",
	totalPlaylists: "总播放列表数",
	totalPrice: "总价",
	totalProducts: "产品总数",
	totalRevenue: "总收入",
	totalTickets: "票据总数",
	totalTracks: "总曲目数",
	totalUses: "总使用次数",
	totalValue: "总价值",
	track: "曲目",
	trackPlaylist: "曲目播放列表",
	tracks: "曲目",
	tracksByArtist: "按艺术家分类的曲目",
	transportAllowance: "交通补贴",
	trash: "垃圾桶",
	trashAutoDeleteWarning: "垃圾自动删除警告",
	trashEmptied: "垃圾桶已清空",
	trashedOn: "删除于",
	tryAgain: "再试一次",
	tue: "星期二",
	type: "类型",
	uncoveredInterval: "未覆盖区间",
	undefined: "未定义",
	undo: "撤销",
	university: "大学",
	universityDegree: "大学学位",
	universityDepartment: "大学系",
	unjustifiedAbsence: "无故缺勤",
	unknown: "未知",
	unknownArtist: "未知艺术家",
	unnamed: "未命名",
	unnamedClient: "未命名客户",
	unnamedTrack: "未命名曲目",
	unpaid: "无薪",
	unreadMessages: "未读消息",
	unresolvedMissingIntervals: "未解决的缺失区间 — 薪资可能不准确",
	upcomingBirthdays: "即将到来的生日",
	update: "更新",
	updatedAt: "更新时间",
	updates: "更新",
	upload: "上传",
	uploadDate: "上传日期",
	uploading: "上传中",
	uploads: "上传",
	uptime: "运行时间",
	urgent: "紧急",
	used: "已使用",
	usedCount: "使用次数",
	usedVacation: "已用假期",
	user: "用户",
	userArchive: "用户档案",
	userDashboard: "用户仪表板",
	userDeleted: "已删除",
	userEntered: "用户进入了",
	userProfile: "用户资料",
	userPayrollCalcUsesAttendance:
		"此计算使用 {monthKey} 的标准考勤与请假汇总，然后应用人力资源设置中的现行税务规则。",
	userUpdated: "已更新",
	userVisited: "用户访问了",
	username: "用户名",
	users: "人力资源",
	vacationBalance: "假期余额",
	vacationDaysForPeriod: "所选期间的假期天数",
	vacationInterval: "假期区间",
	vacationPay: "假期工资",
	value: "值",
	version: "版本",
	viber: "Viber",
	video: "视频",
	view: "查看",
	viewAll: "查看所有",
	viewDetails: "查看详情",
	viewMore: "查看更多",
	viewProject: "查看项目",
	viewSteps: "查看步骤",
	viewTrash: "查看垃圾桶",
	village: "村",
	villages: "村庄列表",
	visitation: "访问",
	visitationDeadline: "访问截止日期",
	visitationDelays: "访问延误",
	voltage: "电压",
	voltageLevel: "电压等级",
	volumes: "卷",
	voluntaryPensionAmount: "自愿养老金金额",
	voluntaryPensionRate: "自愿养老金费率（%）",
	vsPreviousPeriod: "与上一期间相比",
	warning: "警告",
	warrantyDesc: "保修描述",
	warrantyEnd: "保修结束",
	warrantyProvider: "保修供应商",
	warrantyStart: "保修开始",
	watchers: "观察者",
	weatherAriaYerevanForecast: "埃里温天气预报",
	weatherCityYerevan: "埃里温",
	weatherClear: "晴朗",
	weatherCloudy: "多云",
	weatherDrizzle: "毛毛雨",
	weatherFog: "雾",
	weatherForecastUnavailable: "预报不可用",
	weatherHeadingYerevan: "埃里温天气",
	weatherHumidity: "湿度",
	weatherLoadingShort: "天气",
	weatherNextHours: "接下来几小时",
	weatherPartlyCloudy: "局部多云",
	weatherRain: "雨",
	weatherSnow: "雪",
	weatherThunderstorm: "雷暴",
	weatherUnknown: "预报",
	weatherWind: "风",
	weatherWindUnit: "公里/小时",
	wed: "星期三",
	weekly: "按周",
	whatToDo: "该做什么",
	whatToDoLink: "该做什么",
	whatsapp: "WhatsApp",
	withAttachments: "带附件",
	withCoins: "带币",
	withFavorites: "带收藏",
	workDays: "工作日数",
	workInformation: "工作信息",
	workTime: "工作时间",
	workedDays: "工作天数",
	workedHours: "已工作小时",
	working: "工作中",
	workingDays: "工作日",
	workingHoursByDay: "按天工作时间",
	workingMinutes: "工作分钟",
	workingState: "工作状态",
	workingStatus: "工作状态",
	write: "写",
	writeUsIfThereAreAnyQuestions: "如果有任何问题，请写信给我们",
	writingContent: "写作内容",
	writingNumber: "写作编号",
	yes: "是",
	yesNextStep: "是的，进行下一步",
	yesPreviousStep: "是的，返回上一步",
	youWontBeAbleToRevert: "您将无法恢复此操作！",
	yourFileHasBeenDeleted: "您的文件已被删除。",
	yourFileHasBeenNotSaved: "您的文件未保存。",
	yourFileHasBeenSaved: "您的文件已保存。",
	zipCode: "邮政编码",
	zipCodes: "邮政编码",
	vacationIntervalNoDeduction: "非工作日不扣减假期",
	knowledgeDashboardLoadFailed: "无法加载仪表板",
	knowledgeArticlesLoadFailed: "无法加载文章",
	knowledgeBase: "知识库",
	knowledgeCreate: "创建",
	knowledgeRunAutoDocs: "运行自动文档",
	knowledgeTotalArticles: "文章总数",
	knowledgePublished: "已发布",
	knowledgeDrafts: "草稿",
	knowledgeAutoGenerated: "自动生成",
	knowledgeLatestUpdatedArticles: "最近更新的文章",
	knowledgeArticles: "文章",
	knowledgeNewArticle: "新文章",
	knowledgeFilterArticles: "筛选文章",
	knowledgeCategories: "分类",
	knowledgeParentCategory: "父分类",
	knowledgeIcon: "图标",
	knowledgeColor: "颜色",
	knowledgeSortOrder: "排序顺序",
	knowledgeCategorySaved: "分类已保存",
	knowledgeCategoryDeleted: "分类已删除",
	knowledgeSearch: "搜索",
	knowledgeSearchArticles: "搜索文章",
	knowledgePath: "路径",
	knowledgeAutoGeneratedDocs: "自动生成的文档",
	knowledgeSingleRoute: "单一路由",
	knowledgeNoScreenshots: "无截图",
	knowledgeGenerateDocumentation: "生成文档",
	knowledgeImportGeneratedDocs: "导入生成的文档",
	knowledgeDocumentationGenerationStarted: "文档生成已开始",
	knowledgeImported: "已导入",
	knowledgeGeneratedDocsImported: "已导入 {count} 个生成的文档",
	knowledgeStarted: "已开始",
	knowledgeFinished: "已完成",
	knowledgeRun: "运行",
	knowledgeOutput: "输出",
	knowledgeStatus_draft: "草稿",
	knowledgeStatus_published: "已发布",
	knowledgeStatus_archived: "已归档",
	knowledgeVisibility_public: "公开",
	knowledgeVisibility_private: "私有",
	knowledgeVisibility_company: "公司",
	knowledgeRunStatus_idle: "空闲",
	knowledgeRunStatus_running: "运行中",
	knowledgeRunStatus_completed: "已完成",
	knowledgeRunStatus_failed: "失败",
	meetings: "会议",
	meetingsListSubtitle: "已安排的会议室，附带 APIT 聊天和日历。",
	meetingsCreateMeeting: "创建会议",
	meetingsEditMeeting: "编辑会议",
	meetingsCreateSubtitle: "会议 = 日历事件 + 聊天组 + 视频房间。",
	meetingsMeetingType: "会议类型",
	meetingsDate: "日期",
	meetingsStartTime: "开始时间",
	meetingsEndTime: "结束时间",
	meetingsTimezone: "时区",
	meetingsVisibility: "可见性",
	meetingsParticipants: "参与者",
	meetingsGroupsDepartments: "组/部门",
	meetingsOptionalGroupIds: "可选组 ID",
	meetingsLocation: "地点",
	meetingsReminderTime: "提醒时间",
	meetingsMinutesShort: "分钟",
	meetingsAgenda: "议程",
	meetingsAgendaPlaceholder: "启动\n设计评审\n下一步",
	meetingsRecordingEnabled: "启用录制",
	meetingsAllowJoinBeforeHost: "允许主持人前加入",
	meetingsMuteUsersOnEntry: "进入时静音用户",
	meetingsAllowScreenSharing: "允许屏幕共享",
	meetingsSaveAsDraft: "保存为草稿",
	meetingsSaveMeeting: "保存会议",
	meetingsCreateAndNotifyUsers: "创建并通知用户",
	meetingsSaved: "会议已保存",
	meetingsSaveFailed: "无法保存会议",
	meetingsJoin: "加入",
	meetingsOpenChat: "打开聊天",
	meetingsParticipantsCount: "{count} 位参与者",
	meetingsType_video: "视频",
	meetingsType_audio: "音频",
	meetingsType_in_person: "线下",
	meetingsType_hybrid: "混合",
	meetingsVisibility_private: "私有",
	meetingsVisibility_company: "公司",
	meetingsVisibility_department: "部门",
	meetingsStatus_draft: "草稿",
	meetingsStatus_scheduled: "已安排",
	meetingsStatus_live: "进行中",
	meetingsStatus_ended: "已结束",
	meetingsStatus_cancelled: "已取消",
	aiSettingsAction: "操作",
	aiSettingsAllowedModules: "允许的模块",
	aiSettingsApprove: "批准",
	aiSettingsApprovalFailed: "批准失败",
	aiSettingsDisabled: "已禁用",
	aiSettingsEnabled: "已启用",
	aiSettingsEvent: "事件",
	aiSettingsLogs: "日志",
	aiSettingsLoadFailed: "加载AI设置失败",
	aiSettingsNoGateway: "未配置网关",
	aiSettingsNoPendingApprovals: "没有待处理的批准",
	aiSettingsNoLogs: "没有日志",
	aiSettingsNoPermission: "缺少AI管理员权限。",
	aiSettingsPendingApprovals: "待处理的批准",
	aiSettingsReject: "拒绝",
	aiSettingsRejectFailed: "拒绝失败",
	aiSettingsRefresh: "刷新",
	aiSettingsRequireApproval: "需要批准",
	aiSettingsStatus: "状态",
	aiSettingsTime: "时间",
	aiSettingsTitle: "AI设置",
	aiSettingsTool: "工具",
	aiSettingsUser: "用户",
	aiSettingsUpdateFailed: "更新设置失败",
	aiSettingsDefaultMode: "默认模式",
	aiSettingsReadOnly: "只读",
	aiSettingsApprovalRequired: "需要批准",
	aiSettingsAdminOnly: "仅限管理员",
	financeActiveCurrencies: "{count} 种活跃货币",
	financeAddCurrency: "添加货币",
	financeCurrencyCode: "代码",
	financeCurrencyCoefficient: "系数",
	financeCurrencyDefault: "默认",
	financeCurrencyName: "名称",
	financeCurrencySymbol: "符号",
	financeCurrencyUse: "使用",
	financeLoadFailed: "加载财务设置失败",
	financeSaveSettings: "保存设置",
	financeSavedMessage: "财务设置已保存",
	financeSaveFailed: "保存财务设置失败",
	financeSelectedDefault: "选定的默认值:",
	financeSettingsSubtitle: "此处的货币控制财务和订单页面中的默认货币显示。",
	financeSettingsTitle: "财务设置",
	hrAccrualCoeffPreview: "系数预览",
	hrAccrualCoeffPreviewLine1: "{accrualWorkedHours} 工作小时 → {accrualVacationHours} 假期小时",
	hrAccrualCoeffPreviewLine2: "每工作小时赚取的假期小时: {hourlyCoefficient}",
	hrAccrualCoeffStoredNote:
		"后端以分钟为单位存储此应计，以便工资单和假期余额可以使用部分日期值而不会舍入偏差。",
	hrAccrualFixedYearly: "固定年假",
	hrAccrualFixedYearlyDesc: "使用现有的每日或每月时间表在全年内累计配置的假期天数。",
	hrAccrualModelChoice: "选择一个活跃的应计模式。年度天数和工作小时系数使用OR逻辑，而不是结合。",
	hrAccrualSuffixMin: "分钟",
	hrAccrualVacationMinutesEarned: "赚取的假期分钟",
	hrAccrualVacationMinutesEarnedDesc: "每个工作时间单位应计的假期分钟数。",
	hrAccrualWorkBreak: "工作休息",
	hrAccrualWorkBreakDesc: "分类为不在办公室间隔中的休息的每日未覆盖分钟。",
	hrAccrualWorkedHoursModel: "工作小时至假期小时",
	hrAccrualWorkedHoursModelDesc: "使用可配置的工作小时系数从实际工作时间累计假期。",
	hrAccrualWorkedMinutesUnit: "工作分钟单位",
	hrAccrualWorkedMinutesUnitDesc: "多少工作分钟应该产生一个应计单位。",
	hrWeekdayFri: "周五",
	hrWeekdayMon: "周一",
	hrWeekdaySat: "周六",
	hrWeekdaySun: "周日",
	hrWeekdayThu: "周四",
	hrWeekdayTue: "周二",
	hrWeekdayWed: "周三",
	knowledgeSettingsAiEnabled: "AI已启用",
	knowledgeSettingsAiModel: "AI模型",
	knowledgeSettingsAiProvider: "AI提供商",
	knowledgeSettingsEnableAutoDocs: "启用自动文档",
	knowledgeSettingsLanguage: "默认语言",
	knowledgeSettingsMaxSizeMb: "最大文章大小 MB",
	knowledgeSettingsRootCategory: "自动文档根类别",
	knowledgeSettingsSaveSettings: "保存设置",
	knowledgeSettingsSaved: "知识库设置已更新",
	knowledgeSettingsTitle: "设置",
	knowledgeSettingsUploadExt: "允许的上传扩展名",
	knowledgeSettingsVisibility: "默认可见性",
	nvrAddFromList: "从列表添加摄像机",
	nvrCamerasList: "摄像机列表",
	nvrChannel: "频道",
	nvrChannelId: "ID",
	nvrChannelName: "名称",
	nvrChannelsTitle: "从此NVR注册的频道",
	nvrConnectionDesc:
		"输入IP、端口和路径模板(仅 /.../{channel}... — 如VLC中那样，没有rtsp://部分)。添加RTSP用户名和密码(大多数NVR需要它们)。单击保存以运行自动网络扫描，或使用下面从路径添加摄像机以不进行扫描的情况下注册频道。打开摄像机进行实时查看;在办公室地图上，照常放置设备。",
	nvrConnectionTitle: "NVR — 所有频道的一个连接",
	nvrDiscoveryFailed: "发现失败",
	nvrEnterPaths: "输入至少一个频道或路径。",
	nvrFoundChannels: "找到 {n} 个频道。",
	nvrFullUrl: "完整URL(频道101 — 自动来自上面的字段)",
	nvrInitError: "无法初始化NVR。重新加载页面。",
	nvrIp: "NVR IP",
	nvrIpPasswordRequired: "需要NVR IP和保存的密码。设置密码，保存，我们将在下次保存时扫描频道。",
	nvrLoadFailed: "加载NVR失败",
	nvrLiveStatus: "实时状态",
	nvrManualDesc:
		"当自动扫描失败时(例如API无法到达NVR)，在此列出频道。每行使用一个:频道号如101、201、路径如/Streaming/Channels/102或完整的rtsp://URL。当您仅输入数字时，路径与您的RTSP路径模板结合。如果更改了IP或模板，请先保存NVR，然后添加行并单击按钮。",
	nvrManualTitle: "从RTSP路径添加摄像机(无服务器扫描)",
	nvrNotReady: "NVR未准备好。重新加载页面。",
	nvrNotReadyShort: "NVR未准备好。",
	nvrNotWorking: "不工作",
	nvrOfficeMap: "办公室地图",
	nvrOffline: "离线",
	nvrOnline: "在线",
	nvrPasswordChangeNote: "更改并保存以更新保存的密码。",
	nvrPasswordLeaveBlank: "留空以保持当前密码",
	nvrPasswordRequired: "大多数NVR需要发现频道和流传输。",
	nvrPasswordStoredLeaveBlank: "密码已保存;留空以保持它，或键入新密码。",
	nvrRegisterFailed: "无法注册路径",
	nvrRegisteredCameras: "注册了 {n} 个摄像机。",
	nvrRtspPassword: "RTSP密码",
	nvrRtspPathTemplate: "RTSP路径模板",
	nvrRtspPathTemplateHint: "仅输入带有 {channel} 的路径。不要在此输入完整的rtsp://字符串。",
	nvrRtspUsername: "RTSP用户名",
	nvrScanChannels: "再次扫描频道",
	nvrScanHint: "这将保存当前连接字段，然后扫描。",
	nvrWorkingState: "工作状态",
	nvrWorking: "工作中",
	nvrGridEmpty: "此NVR还没有链接频道。在NVR页面上运行发现。",
	nvrGridLoadFailed: "加载频道失败",
	nvrGridLoading: "加载频道…",
	nvrGridStreamFailed: "启动失败",
	nvrGridStreamStopped: "流已停止",
	nvrGridTitle: "所有NVR频道",
	securityRecordingActiveDays: "活跃日期",
	securityRecordingDesc:
		"为开启了'在服务器上录制'的摄像机启用服务器端录制。每个摄像机也可以在下方有自己的时间表。",
	securityRecordingEndTime: "结束时间",
	securityRecordingGlobalEnable: "全局启用录制",
	securityRecordingGlobalEnableDesc:
		"主开关 — 禁用此开关将停止所有录制，无论每个摄像机的设置如何。",
	securityRecordingLoadFailed: "加载安全设置失败",
	securityRecordingLocalFs: "本地文件系统",
	securityRecordingLocalPathNote:
		"本地路径通过服务器上的 SECURITY_RECORDING_LOCAL_PATH 环境变量进行配置。",
	securityRecordingNoScheduleNote: "无时间表 — 当启用服务器上的录制时，摄像机将24/7录制。",
	securityRecordingRetentionDays: "保留(天)",
	securityRecordingRetentionDesc: "早于此的片段将自动删除。",
	securityRecordingS3: "S3/兼容的对象存储",
	securityRecordingS3Note:
		"S3凭证通过服务器上的环境变量进行配置(AWS_ACCESS_KEY_ID、AWS_SECRET_ACCESS_KEY等)。",
	securityRecordingSaveSettings: "保存设置",
	securityRecordingSaved: "安全设置已保存。",
	securityRecordingSaveFailed: "保存设置失败",
	securityRecordingScheduleDesc:
		"此时间表适用于所有启用了服务器上录制且没有自己的每摄像机时间表覆盖的摄像机。",
	securityRecordingScheduleEnable: "启用默认时间表(仅在设定的小时内录制)",
	securityRecordingScheduleNote: "录制将在所选天数的这些小时之间运行。在此窗口外，录制将自动暂停。",
	securityRecordingScheduleTitle: "默认录制时间表",
	securityRecordingSegmentLength: "片段长度(分钟)",
	securityRecordingSegmentLengthDesc: "这控制每个摄像机页面上新视频出现的频率。",
	securityRecordingStartTime: "开始时间",
	securityRecordingStorage: "存储",
	securityRecordingStorageBackend: "存储后端",
	securityRecordingTitle: "服务器上的摄像机录制",
	securitySurveillanceCameraMedia: "摄像机媒体",
	securitySurveillanceDashboard: "监控仪表板",
	securitySurveillanceNoCameras: "未找到摄像机。",
	securitySurveillanceOffline: "离线",
	securitySurveillanceOnline: "在线",
	teamWorkload: "团队工作量",
	workloadTasks: "任务",
	workloadTickets: "工单",
	workloadSteps: "步骤",
	assignedEmployee: "分配员工",
	boughtDate: "购买日期",
	broken: "损坏",
	depreciation: "折旧",
	deviceStatus: "设备状态",
	handoverDocument: "交接文件",
	maintenanceSchedule: "维护计划",
	qrCode: "二维码",
	repair: "维修",
	repairHistory: "维修历史",
	replacementDate: "更换日期",
	retired: "已退役",
	returnDocument: "归还文件",
	warrantyDate: "保修日期",
	noOpenWorkload: "没有待处理工作量",
	attendanceTable: "出勤表",
	filteredFrom: "筛选自",
	weekend: "周末",
	late: "迟到",
	lateDeparture: "晚退",
	employees: "员工",
	exportToExcel: "导出到 Excel",
	overtime: "加班",
	attendanceNextRefresh: "下次刷新",
	refreshAttendanceDevices: "从考勤设备刷新数据",
	attendanceSyncSuccess: "考勤设备已同步",
	attendanceSyncFailed: "考勤设备同步失败",
	// User account security / profile
	contactInformation: "联系信息",
	accountSecurity: "账户安全",
	accountStatus: "账户状态",
	accountStatusActive: "活跃",
	accountStatusLocked: "已锁定",
	mustChangePassword: "必须更改密码",
	lockedAt: "锁定时间",
	passwordLastChanged: "密码上次更改",
	accountSecurityDesc: "当前密码永远不会显示。需要更改凭据时，请使用临时密码或安全重置链接。",
	accountSecurityHint: "需要立即轮换凭据时使用「重置密码」。希望用户自行选择新密码且管理员看不到任何密钥时，使用「发送重置链接」。",
	lockAccount: "锁定账户",
	unlockAccount: "解锁账户",
	forcePasswordChangeAction: "强制更改密码",
	clearForcedPasswordChange: "取消强制更改密码",
	resetPassword: "重置密码",
	sendResetLink: "发送重置链接",
	sessionVisibilityRequiresPermission: "查看会话和设备需要额外权限。",
	resetPasswordConfirmTitle: "重置此密码？",
	resetPasswordConfirmText: "将生成临时密码，用户下次登录时必须更改。",
	temporaryPasswordGenerated: "已生成临时密码",
	temporaryPasswordShareHint: "请仅通过安全渠道分享。",
	sendResetLinkConfirmTitle: "发送密码重置链接？",
	sendResetLinkConfirmText: "将向该用户发送一次性安全密码重置链接。",
	passwordResetLinkSent: "密码重置链接已发送。",
	lockAccountConfirmTitle: "锁定此账户？",
	unlockAccountConfirmTitle: "解锁此账户？",
	lockAccountConfirmText: "在解锁之前，用户将无法登录。",
	unlockAccountConfirmText: "用户将能立即重新登录。",
	accountLockedMsg: "账户已锁定。",
	accountUnlockedMsg: "账户已解锁。",
	forcePasswordChangeConfirmTitle: "下次登录时强制更改密码？",
	removeForcedPasswordChangeConfirmTitle: "取消强制更改密码？",
	forcePasswordChangeConfirmText: "用户只能登录以完成密码更改，然后才能使用平台。",
	removeForcedPasswordChangeConfirmText: "用户将可正常继续登录。",
	forcedPasswordChangeEnabled: "已启用强制更改密码。",
	forcedPasswordChangeRemoved: "已取消强制更改密码。",
	securityUpdated: "安全设置已更新",
	securityActionFailed: "安全操作失败",
	knownDevicesAndSessions: "已知设备和打开的会话",
	knownDevicesAndSessionsDesc: "位置为近似值，通常表示 IP 来源、ISP、VPN 出口或办公网关，而非设备的精确物理位置。",
	openSessionsBadge: "{count} 个打开",
	revokeOtherSessions: "撤销其他会话",
	registeredDevices: "已注册设备",
	unknownDevice: "未知设备",
	unknownBrowser: "未知浏览器",
	unknownOs: "未知操作系统",
	browserOnOs: "{browser}，运行于 {os}",
	firstSeen: "首次出现",
	sessionsBadge: "{count} 个会话",
	currentDevice: "当前设备",
	noKnownDevices: "尚无已知设备记录。",
	approximateLoginOrigins: "近似登录来源",
	sessionDetails: "会话详情",
	device: "设备",
	network: "网络",
	lastActive: "上次活动",
	approximateLocationUnavailable: "近似位置不可用",
	revoke: "撤销",
	noAuthSessions: "尚无身份验证会话记录。",
	sessionOriginApproximateNote: "会话来源数据为近似值。请勿将 IP 地理位置视为设备的确切位置。",
	connectedMeansNote: "「已连接」表示浏览器/应用仍有活动套接字。「已断开」表示浏览器已关闭或离线，但已保存的登录会话在注销、撤销或过期之前可能仍然有效。",
	revokeThisSessionTitle: "撤销此会话？",
	revokeThisSessionText: "所选设备/会话将被强制重新登录。",
	revokeSession: "撤销会话",
	sessionRevoked: "会话已撤销",
	sessionRevokedSuccess: "所选会话已成功撤销。",
	failedToRevokeSession: "撤销会话失败",
	unableToRevokeSession: "无法撤销所选会话。",
	revokeOtherSessionsTitle: "撤销其他会话？",
	revokeOtherSessionsText: "将撤销该用户的所有会话，用户撤销自己的设备时除外当前会话。",
	revokeSessions: "撤销会话",
	sessionsRevoked: "会话已撤销",
	revokedSessionsCount: "已撤销 {count} 个会话。",
	failedToRevokeSessions: "撤销会话失败",
	unableToRevokeSessions: "无法撤销所选会话。",
	failedToLoadSessions: "加载会话失败",
	unableToLoadUserSessions: "无法加载用户会话。",
	sessionStatusRevoked: "已撤销",
	sessionStatusConnected: "已连接",
	sessionStatusDisconnected: "已断开",
	currentSession: "当前",
	passwordChangeOnly: "仅更改密码",
	faceId: "Face ID",
	passwordsNeverShownHint: "此处从不显示密码。请使用“安全”选项卡锁定或解锁此账户、强制更改密码、生成临时密码或发送重置链接。",
	sharedFolders: "共享文件夹",
	flexId: "Flex Id",
	emailNotProvided: "未提供电子邮件",
	anonymousUser: "匿名用户",
	noMapPointsYet: "尚无地图点",
	noMapPointsYetDesc: "尚无带近似坐标的会话位置。后端仍可在没有地理提供商的情况下跟踪设备和会话。",
	googleMapsKeyNotConfigured: "未配置 Google Maps 密钥",
	googleMapsKeyNotConfiguredDesc: "设置 REACT_APP_GOOGLE_MAPS_API_KEY 以呈现近似会话地图。",
	mapFailedToLoad: "地图加载失败",
	mapFailedToLoadDesc: "目前无法加载 Google Maps。",
	approximateLocation: "近似位置",
	attendanceLastRefreshed: "上次刷新",
	quarter: "季度",
	year: "年",
	currentQuarter: "当前季度",
	currentYear: "当前年份",
	chatClearHistory: "清除历史记录",
	chatClearHistoryConfirm: "仅为您清除此聊天的历史记录？",
	chatDeleteForMe: "删除聊天",
	chatDeleteForMeConfirm: "仅为您删除此聊天？您可见的历史记录将被清除，该聊天将从侧边栏中消失。",
	chatBlockUser: "屏蔽用户",
	chatUnblockUser: "取消屏蔽用户",
	chatBlockedSection: "已屏蔽的联系人",
	chatBlockUserConfirm: "屏蔽该用户？对方将无法在此聊天中给您发消息。",
};
